"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.1.2.0 (NJsonSchema v10.0.24.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var AuthHeaders_1 = require("./AuthHeaders");
var operators_1 = require("rxjs/operators");
var rxjs_1 = require("rxjs");
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var moment = require("moment");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
exports.API_BASE_URL = new core_1.InjectionToken('API_BASE_URL');
var ClientBase = /** @class */ (function () {
    function ClientBase() {
    }
    ClientBase.prototype.transformOptions = function (options) {
        var token = AuthHeaders_1.getAuthToken();
        var old_headers = options.headers;
        var new_headers = {};
        old_headers.keys().forEach(function (k) {
            new_headers[k] = old_headers.get(k);
        });
        if (token && token != '') {
            new_headers["Authorization"] = "Bearer " + token;
        }
        Object.keys(AuthHeaders_1.default_headers).forEach(function (k) {
            new_headers[k] = AuthHeaders_1.default_headers[k];
        });
        options.headers = new http_1.HttpHeaders(new_headers);
        //console.log("HTTP call, options: " + JSON.stringify(options));
        return Promise.resolve(options);
    };
    ClientBase.prototype.transformResult = function (url, response, processor) {
        // TODO: Return own result or throw exception to change default processing behavior, 
        // or call processor function to run the default processing logic
        //console.log("Service call: " + url);
        return processor(response);
    };
    return ClientBase;
}());
exports.ClientBase = ClientBase;
var AdsClient = /** @class */ (function (_super) {
    __extends(AdsClient, _super);
    function AdsClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    AdsClient.prototype.getAds = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Ads";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetAds(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetAds(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdsClient.prototype.processGetAds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Ads.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdsClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AdsClient_Factory() { return new AdsClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: AdsClient, providedIn: "root" });
    return AdsClient;
}(ClientBase));
exports.AdsClient = AdsClient;
var AdveristmentsClient = /** @class */ (function (_super) {
    __extends(AdveristmentsClient, _super);
    function AdveristmentsClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    AdveristmentsClient.prototype.markAsSeenByDemo = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/markAsSeen";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processMarkAsSeenByDemo(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processMarkAsSeenByDemo(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processMarkAsSeenByDemo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdvertisementMarkAsSeenResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getCategories = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetCategories";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetCategories(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetCategories(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetCategories = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                        var item = resultData200_1[_i];
                        result200.push(DTOAdvertisementCategory.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getCategoriesJS = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/getcategories/js";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetCategoriesJS(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetCategoriesJS(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetCategoriesJS = function (response) {
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getRegions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetRegions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetRegions(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetRegions(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetRegions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                        var item = resultData200_2[_i];
                        result200.push(DTORegion.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getRegionsOnly = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetRegionsOnly";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetRegionsOnly(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetRegionsOnly(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetRegionsOnly = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                        var item = resultData200_3[_i];
                        result200.push(DTORegion.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getChildrenSubRegions = function (subRegionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetChildrenSubRegions/{subRegionId}";
        if (subRegionId === undefined || subRegionId === null)
            throw new Error("The parameter 'subRegionId' must be defined.");
        url_ = url_.replace("{subRegionId}", encodeURIComponent("" + subRegionId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetChildrenSubRegions(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetChildrenSubRegions(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetChildrenSubRegions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                        var item = resultData200_4[_i];
                        result200.push(DTOSubRegion.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.repost = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/repost";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processRepost(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processRepost(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processRepost = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdvertistmentRepostResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.create = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdveristmentCreateResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.update = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdveristmentUpdateResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.delete = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/delete";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processDelete = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdveristmentDeleteResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getAdvertisementData = function (advId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetAdvertisementData?";
        if (advId === null)
            throw new Error("The parameter 'advId' cannot be null.");
        else if (advId !== undefined)
            url_ += "advId=" + encodeURIComponent("" + advId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetAdvertisementData(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetAdvertisementData(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetAdvertisementData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdveristmentGetResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.get = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/get";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdveristmentGetResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getAdveristmentGetModel = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetAdveristmentGetModel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetAdveristmentGetModel(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetAdveristmentGetModel(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetAdveristmentGetModel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdveristmentGetModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getSearchParams = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/SearchParams";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetSearchParams(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetSearchParams(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetSearchParams = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SearchParamsResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getGoogleKey = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetGoogleKey";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetGoogleKey(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetGoogleKey(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetGoogleKey = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getBlogUrl = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetBlogUrl";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetBlogUrl(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetBlogUrl(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetBlogUrl = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.createAdWriteInformation = function (data) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/CreateAdWriteInformation";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(data);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCreateAdWriteInformation(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCreateAdWriteInformation(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processCreateAdWriteInformation = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdWritterInformationResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AdveristmentsClient_Factory() { return new AdveristmentsClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: AdveristmentsClient, providedIn: "root" });
    return AdveristmentsClient;
}(ClientBase));
exports.AdveristmentsClient = AdveristmentsClient;
var AuthClient = /** @class */ (function (_super) {
    __extends(AuthClient, _super);
    function AuthClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    AuthClient.prototype.login = function (user) {
        var _this = this;
        var url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(user);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processLogin(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processLogin(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AuthClient.prototype.processLogin = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = LoginResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AuthClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthClient_Factory() { return new AuthClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: AuthClient, providedIn: "root" });
    return AuthClient;
}(ClientBase));
exports.AuthClient = AuthClient;
var BannersClient = /** @class */ (function (_super) {
    __extends(BannersClient, _super);
    function BannersClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    BannersClient.prototype.getBannersEnabled = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Banners/GetBannersEnabled";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetBannersEnabled(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetBannersEnabled(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    BannersClient.prototype.processGetBannersEnabled = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    BannersClient.prototype.getUseBannerProviders = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Banners/GetUseBannerProviders";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetUseBannerProviders(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetUseBannerProviders(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    BannersClient.prototype.processGetUseBannerProviders = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    BannersClient.prototype.getAllUserBaners = function (isMobile) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Banners/GetAllUserBaners?";
        if (isMobile === null)
            throw new Error("The parameter 'isMobile' cannot be null.");
        else if (isMobile !== undefined)
            url_ += "isMobile=" + encodeURIComponent("" + isMobile) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetAllUserBaners(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetAllUserBaners(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    BannersClient.prototype.processGetAllUserBaners = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                        var item = resultData200_5[_i];
                        result200.push(Baners.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    BannersClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BannersClient_Factory() { return new BannersClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: BannersClient, providedIn: "root" });
    return BannersClient;
}(ClientBase));
exports.BannersClient = BannersClient;
var CaptchaClient = /** @class */ (function (_super) {
    __extends(CaptchaClient, _super);
    function CaptchaClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    CaptchaClient.prototype.getCaptchaKey = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Captcha/GetCaptchaKey";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetCaptchaKey(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetCaptchaKey(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    CaptchaClient.prototype.processGetCaptchaKey = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    CaptchaClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CaptchaClient_Factory() { return new CaptchaClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: CaptchaClient, providedIn: "root" });
    return CaptchaClient;
}(ClientBase));
exports.CaptchaClient = CaptchaClient;
var ConversationClient = /** @class */ (function (_super) {
    __extends(ConversationClient, _super);
    function ConversationClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    ConversationClient.prototype.deleteConversation = function (deleteRequestModel) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/delete";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(deleteRequestModel);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processDeleteConversation(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processDeleteConversation(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processDeleteConversation = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ConversationDeleteResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.getConversation = function (conversationId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/getConversation?";
        if (conversationId === null)
            throw new Error("The parameter 'conversationId' cannot be null.");
        else if (conversationId !== undefined)
            url_ += "conversationId=" + encodeURIComponent("" + conversationId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetConversation(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetConversation(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processGetConversation = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetConversationResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.getConversations = function (requestModel, perPage, page) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/get?";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(requestModel);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetConversations(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetConversations(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processGetConversations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = UserConversationsResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.getConversationsCount = function (requestModel) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/getCount";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(requestModel);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetConversationsCount(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetConversationsCount(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processGetConversationsCount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.sendConversationMessage = function (requestModel) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/sendConversationMessage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(requestModel);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSendConversationMessage(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSendConversationMessage(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processSendConversationMessage = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = MessageSubmitResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.sendStartingMessage = function (requestModel) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/sendStartingMessage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(requestModel);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSendStartingMessage(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSendStartingMessage(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processSendStartingMessage = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = MessageSubmitResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.getUnreadedMessages = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/GetUnreadedMessages";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetUnreadedMessages(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetUnreadedMessages(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processGetUnreadedMessages = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.setReadedMessages = function (messagesIds, conversationId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/SetReadedMessages?";
        if (conversationId === null)
            throw new Error("The parameter 'conversationId' cannot be null.");
        else if (conversationId !== undefined)
            url_ += "conversationId=" + encodeURIComponent("" + conversationId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(messagesIds);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSetReadedMessages(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSetReadedMessages(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processSetReadedMessages = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.getActiveConversationId = function (advertisementId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/GetActiveConversationId?";
        if (advertisementId === null)
            throw new Error("The parameter 'advertisementId' cannot be null.");
        else if (advertisementId !== undefined)
            url_ += "advertisementId=" + encodeURIComponent("" + advertisementId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetActiveConversationId(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetActiveConversationId(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processGetActiveConversationId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.restoreConvHasMessages = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/restoreConvsHasMessages";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processRestoreConvHasMessages(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processRestoreConvHasMessages(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processRestoreConvHasMessages = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConversationClient_Factory() { return new ConversationClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: ConversationClient, providedIn: "root" });
    return ConversationClient;
}(ClientBase));
exports.ConversationClient = ConversationClient;
var EmojiClient = /** @class */ (function (_super) {
    __extends(EmojiClient, _super);
    function EmojiClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    EmojiClient.prototype.getEmojis = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Emoji/GetEmojis";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetEmojis(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetEmojis(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    EmojiClient.prototype.processGetEmojis = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = EmojiResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    EmojiClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EmojiClient_Factory() { return new EmojiClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: EmojiClient, providedIn: "root" });
    return EmojiClient;
}(ClientBase));
exports.EmojiClient = EmojiClient;
var FileClient = /** @class */ (function (_super) {
    __extends(FileClient, _super);
    function FileClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    FileClient.prototype.read = function (pathInfo, maxWidth, maxheight) {
        var _this = this;
        var url_ = this.baseUrl + "/FileGet/{pathInfo}/{maxWidth}x{maxheight}";
        if (pathInfo === undefined || pathInfo === null)
            throw new Error("The parameter 'pathInfo' must be defined.");
        url_ = url_.replace("{pathInfo}", encodeURIComponent("" + pathInfo));
        if (maxWidth === undefined || maxWidth === null)
            throw new Error("The parameter 'maxWidth' must be defined.");
        url_ = url_.replace("{maxWidth}", encodeURIComponent("" + maxWidth));
        if (maxheight === undefined || maxheight === null)
            throw new Error("The parameter 'maxheight' must be defined.");
        url_ = url_.replace("{maxheight}", encodeURIComponent("" + maxheight));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processRead(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processRead(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    FileClient.prototype.processRead = function (response) {
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    FileClient.prototype.read2 = function (pathInfo) {
        var _this = this;
        var url_ = this.baseUrl + "/FileGet/{pathInfo}";
        if (pathInfo === undefined || pathInfo === null)
            throw new Error("The parameter 'pathInfo' must be defined.");
        url_ = url_.replace("{pathInfo}", encodeURIComponent("" + pathInfo));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processRead2(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processRead2(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    FileClient.prototype.processRead2 = function (response) {
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    FileClient.prototype.temporaryUpload = function () {
        var _this = this;
        var url_ = this.baseUrl + "/File/TemporaryUpload";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processTemporaryUpload(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processTemporaryUpload(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    FileClient.prototype.processTemporaryUpload = function (response) {
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    FileClient.prototype.temporaryBanerUpload = function () {
        var _this = this;
        var url_ = this.baseUrl + "/File/TemporaryBanerUpload";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processTemporaryBanerUpload(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processTemporaryBanerUpload(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    FileClient.prototype.processTemporaryBanerUpload = function (response) {
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    FileClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FileClient_Factory() { return new FileClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: FileClient, providedIn: "root" });
    return FileClient;
}(ClientBase));
exports.FileClient = FileClient;
var GeolocationClient = /** @class */ (function (_super) {
    __extends(GeolocationClient, _super);
    function GeolocationClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    GeolocationClient.prototype.subRegionByLatLng = function (latitude, longitude) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/ClosestSubRegionByLatLng?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSubRegionByLatLng(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSubRegionByLatLng(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processSubRegionByLatLng = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SubRegion.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.asd = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/Test";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processAsd(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processAsd(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processAsd = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                        var item = resultData200_6[_i];
                        result200.push(SubRegion.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.subregionInformation = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/SubregionInformation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSubregionInformation(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSubregionInformation(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processSubregionInformation = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SubRegion.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.cityMostPopulation = function (top) {
        var _this = this;
        var url_ = this.baseUrl + "/citybypopulation?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCityMostPopulation(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCityMostPopulation(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processCityMostPopulation = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                        var item = resultData200_7[_i];
                        result200.push(SubRegion.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.cityMostPopulationJS = function (top) {
        var _this = this;
        var url_ = this.baseUrl + "/citybypopulation/js?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCityMostPopulationJS(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCityMostPopulationJS(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processCityMostPopulationJS = function (response) {
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.getSubregionByZip = function (zip) {
        var _this = this;
        var url_ = this.baseUrl + "/SubregionByZip?";
        if (zip !== undefined)
            url_ += "zip=" + encodeURIComponent("" + zip) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetSubregionByZip(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetSubregionByZip(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processGetSubregionByZip = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SubRegion.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.getSubregionByIP = function (ip) {
        var _this = this;
        var url_ = this.baseUrl + "/GetSubregionByIP?";
        if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetSubregionByIP(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetSubregionByIP(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processGetSubregionByIP = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SubRegion.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.ip = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/ipstack";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processIp(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processIp(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processIp = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetAdvertisementsRequest.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.getGeolocationSearchModel = function (ip) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/ipdata?";
        if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetGeolocationSearchModel(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetGeolocationSearchModel(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processGetGeolocationSearchModel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdveristmentGetModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.clientIp = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/clientIP";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processClientIp(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processClientIp(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processClientIp = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_8 = resultData200; _i < resultData200_8.length; _i++) {
                        var item = resultData200_8[_i];
                        result200.push(item);
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.getNearestCity = function (ip) {
        var _this = this;
        var url_ = this.baseUrl + "/GetNearestCity?";
        if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetNearestCity(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetNearestCity(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processGetNearestCity = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.allSubregions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/AllSubregions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processAllSubregions(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processAllSubregions(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processAllSubregions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_9 = resultData200; _i < resultData200_9.length; _i++) {
                        var item = resultData200_9[_i];
                        result200.push(SubRegion.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.allRegions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/AllRegions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processAllRegions(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processAllRegions(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processAllRegions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_10 = resultData200; _i < resultData200_10.length; _i++) {
                        var item = resultData200_10[_i];
                        result200.push(Region.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.getSubregion = function (subregionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/GetSubregion?";
        if (subregionId === null)
            throw new Error("The parameter 'subregionId' cannot be null.");
        else if (subregionId !== undefined)
            url_ += "subregionId=" + encodeURIComponent("" + subregionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetSubregion(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetSubregion(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processGetSubregion = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SubRegion.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.getRegion = function (regionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/GetRegion?";
        if (regionId === null)
            throw new Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetRegion(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetRegion(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processGetRegion = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Region.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GeolocationClient_Factory() { return new GeolocationClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: GeolocationClient, providedIn: "root" });
    return GeolocationClient;
}(ClientBase));
exports.GeolocationClient = GeolocationClient;
var ImportDataClient = /** @class */ (function (_super) {
    __extends(ImportDataClient, _super);
    function ImportDataClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    ImportDataClient.prototype.usStates = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/ImportData/usstates";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processUsStates(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processUsStates(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ImportDataClient.prototype.processUsStates = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ImportDataClient.prototype.test = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/ImportData/test";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processTest(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processTest(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ImportDataClient.prototype.processTest = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_11 = resultData200; _i < resultData200_11.length; _i++) {
                        var item = resultData200_11[_i];
                        result200.push(SubRegion.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ImportDataClient.prototype.importPopularity = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/ImportData/popularity";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processImportPopularity(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processImportPopularity(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ImportDataClient.prototype.processImportPopularity = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ImportDataClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ImportDataClient_Factory() { return new ImportDataClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: ImportDataClient, providedIn: "root" });
    return ImportDataClient;
}(ClientBase));
exports.ImportDataClient = ImportDataClient;
var PhoneValidationClient = /** @class */ (function (_super) {
    __extends(PhoneValidationClient, _super);
    function PhoneValidationClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    PhoneValidationClient.prototype.sendPhoneValidationSms = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/send";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSendPhoneValidationSms(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSendPhoneValidationSms(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    PhoneValidationClient.prototype.processSendPhoneValidationSms = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = VerifyPhoneResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    PhoneValidationClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PhoneValidationClient_Factory() { return new PhoneValidationClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: PhoneValidationClient, providedIn: "root" });
    return PhoneValidationClient;
}(ClientBase));
exports.PhoneValidationClient = PhoneValidationClient;
var SampleDataClient = /** @class */ (function (_super) {
    __extends(SampleDataClient, _super);
    function SampleDataClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    SampleDataClient.prototype.zipTest = function (zip) {
        var _this = this;
        var url_ = this.baseUrl + "/api/SampleData/ZipTest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(zip);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processZipTest(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processZipTest(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SampleDataClient.prototype.processZipTest = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SampleDataClient.prototype.weatherForecasts = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/SampleData/WeatherForecasts";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processWeatherForecasts(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processWeatherForecasts(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SampleDataClient.prototype.processWeatherForecasts = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_12 = resultData200; _i < resultData200_12.length; _i++) {
                        var item = resultData200_12[_i];
                        result200.push(WeatherForecast.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SampleDataClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SampleDataClient_Factory() { return new SampleDataClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: SampleDataClient, providedIn: "root" });
    return SampleDataClient;
}(ClientBase));
exports.SampleDataClient = SampleDataClient;
var SeoClient = /** @class */ (function (_super) {
    __extends(SeoClient, _super);
    function SeoClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    SeoClient.prototype.seoTextJs = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Seo/texts/js";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSeoTextJs(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSeoTextJs(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SeoClient.prototype.processSeoTextJs = function (response) {
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SeoClient.prototype.seoPage = function (slug) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Seo?";
        if (slug !== undefined)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSeoPage(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSeoPage(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SeoClient.prototype.processSeoPage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SeoClient.prototype.getMetaSeo = function (slug) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Seo/getMetaSeo?";
        if (slug !== undefined)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetMetaSeo(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetMetaSeo(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SeoClient.prototype.processGetMetaSeo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetSeoMetaTextsResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SeoClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SeoClient_Factory() { return new SeoClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: SeoClient, providedIn: "root" });
    return SeoClient;
}(ClientBase));
exports.SeoClient = SeoClient;
var SitemapClient = /** @class */ (function (_super) {
    __extends(SitemapClient, _super);
    function SitemapClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    SitemapClient.prototype.getSitemap = function () {
        var _this = this;
        var url_ = this.baseUrl + "/sitemap.xml";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetSitemap(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetSitemap(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SitemapClient.prototype.processGetSitemap = function (response) {
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SitemapClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SitemapClient_Factory() { return new SitemapClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: SitemapClient, providedIn: "root" });
    return SitemapClient;
}(ClientBase));
exports.SitemapClient = SitemapClient;
var SubscribtionClient = /** @class */ (function (_super) {
    __extends(SubscribtionClient, _super);
    function SubscribtionClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    SubscribtionClient.prototype.create = function (data) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(data);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CreateServiceResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.subscribtionData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/GetSubscribtionData";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSubscribtionData(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSubscribtionData(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processSubscribtionData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_13 = resultData200; _i < resultData200_13.length; _i++) {
                        var item = resultData200_13[_i];
                        result200.push(SubscribtionData.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.cancelSubscribtion = function (subscribtionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/CancelSubscribtion?";
        if (subscribtionId !== undefined)
            url_ += "subscribtionId=" + encodeURIComponent("" + subscribtionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCancelSubscribtion(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCancelSubscribtion(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processCancelSubscribtion = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.hasUserSubscribtion = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/HasUserSubscribtion";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processHasUserSubscribtion(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processHasUserSubscribtion(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processHasUserSubscribtion = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.createPremiumAdToken = function (data) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/CreatePremiumAdToken";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(data);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCreatePremiumAdToken(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCreatePremiumAdToken(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processCreatePremiumAdToken = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AddPremiumAdTokenResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.getUserPremiumAdTokens = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/GetUserPremiumAdTokens";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetUserPremiumAdTokens(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetUserPremiumAdTokens(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processGetUserPremiumAdTokens = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.createWriteAdToken = function (data) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/CreateWriteAdToken";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(data);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCreateWriteAdToken(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCreateWriteAdToken(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processCreateWriteAdToken = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AddWriteAdTokenResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.getWriteAdToken = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/GetWriteAdToken";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetWriteAdToken(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetWriteAdToken(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processGetWriteAdToken = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.createThirdPartyAdToken = function (data) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/CreateThirdPartyAdToken";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(data);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCreateThirdPartyAdToken(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCreateThirdPartyAdToken(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processCreateThirdPartyAdToken = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AddThirdPartyAdTokenResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.getUserThirdPartyAdTokens = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/GetUserThirdPartyAdTokens";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetUserThirdPartyAdTokens(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetUserThirdPartyAdTokens(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processGetUserThirdPartyAdTokens = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.createBanerAdvertising = function (data) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/CreateBanerAdvertising";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(data);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCreateBanerAdvertising(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCreateBanerAdvertising(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processCreateBanerAdvertising = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AddBanerResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SubscribtionClient_Factory() { return new SubscribtionClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: SubscribtionClient, providedIn: "root" });
    return SubscribtionClient;
}(ClientBase));
exports.SubscribtionClient = SubscribtionClient;
var UserClient = /** @class */ (function (_super) {
    __extends(UserClient, _super);
    function UserClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    UserClient.prototype.register = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/register";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processRegister(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processRegister(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    UserClient.prototype.processRegister = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = RegistrationResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    UserClient.prototype.resetPassword = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/passwordreset";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processResetPassword(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processResetPassword(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    UserClient.prototype.processResetPassword = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ResetPasswordResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    UserClient.prototype.getEmailFromCode = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/getemailfromcode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetEmailFromCode(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetEmailFromCode(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    UserClient.prototype.processGetEmailFromCode = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetEmailFromCodeResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    UserClient.prototype.newPassword = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/newpassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processNewPassword(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processNewPassword(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    UserClient.prototype.processNewPassword = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ResetPasswordResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    UserClient.prototype.validatePhone = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/phoneValidate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processValidatePhone(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processValidatePhone(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    UserClient.prototype.processValidatePhone = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ValidateResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    UserClient.prototype.validateEmail = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/emailValidate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processValidateEmail(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processValidateEmail(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    UserClient.prototype.processValidateEmail = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ValidateResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    UserClient.prototype.deleteAccount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/DeleteAccount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processDeleteAccount(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processDeleteAccount(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    UserClient.prototype.processDeleteAccount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    UserClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserClient_Factory() { return new UserClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: UserClient, providedIn: "root" });
    return UserClient;
}(ClientBase));
exports.UserClient = UserClient;
var VersionClient = /** @class */ (function (_super) {
    __extends(VersionClient, _super);
    function VersionClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    VersionClient.prototype.versionHash = function (t) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Version?";
        if (t !== undefined)
            url_ += "t=" + encodeURIComponent("" + t) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processVersionHash(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processVersionHash(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    VersionClient.prototype.processVersionHash = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    VersionClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VersionClient_Factory() { return new VersionClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: VersionClient, providedIn: "root" });
    return VersionClient;
}(ClientBase));
exports.VersionClient = VersionClient;
var Ads = /** @class */ (function () {
    function Ads(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Ads.prototype.init = function (data) {
        if (data) {
            this.leftAdId = data["leftAdId"] !== undefined ? data["leftAdId"] : null;
            this.rightAdId = data["rightAdId"] !== undefined ? data["rightAdId"] : null;
            this.mobileAdId = data["mobileAdId"] !== undefined ? data["mobileAdId"] : null;
        }
    };
    Ads.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Ads();
        result.init(data);
        return result;
    };
    Ads.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["leftAdId"] = this.leftAdId !== undefined ? this.leftAdId : null;
        data["rightAdId"] = this.rightAdId !== undefined ? this.rightAdId : null;
        data["mobileAdId"] = this.mobileAdId !== undefined ? this.mobileAdId : null;
        return data;
    };
    Ads.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Ads();
        result.init(json);
        return result;
    };
    return Ads;
}());
exports.Ads = Ads;
var ResponseBaseModel = /** @class */ (function () {
    function ResponseBaseModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResponseBaseModel.prototype.init = function (data) {
        if (data) {
            this.error = data["error"] !== undefined ? data["error"] : null;
            this.redirectUrl = data["redirectUrl"] !== undefined ? data["redirectUrl"] : null;
        }
    };
    ResponseBaseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResponseBaseModel();
        result.init(data);
        return result;
    };
    ResponseBaseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error !== undefined ? this.error : null;
        data["redirectUrl"] = this.redirectUrl !== undefined ? this.redirectUrl : null;
        return data;
    };
    ResponseBaseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ResponseBaseModel();
        result.init(json);
        return result;
    };
    return ResponseBaseModel;
}());
exports.ResponseBaseModel = ResponseBaseModel;
var AdvertisementMarkAsSeenResponseModel = /** @class */ (function (_super) {
    __extends(AdvertisementMarkAsSeenResponseModel, _super);
    function AdvertisementMarkAsSeenResponseModel(data) {
        return _super.call(this, data) || this;
    }
    AdvertisementMarkAsSeenResponseModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
    };
    AdvertisementMarkAsSeenResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdvertisementMarkAsSeenResponseModel();
        result.init(data);
        return result;
    };
    AdvertisementMarkAsSeenResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdvertisementMarkAsSeenResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdvertisementMarkAsSeenResponseModel();
        result.init(json);
        return result;
    };
    return AdvertisementMarkAsSeenResponseModel;
}(ResponseBaseModel));
exports.AdvertisementMarkAsSeenResponseModel = AdvertisementMarkAsSeenResponseModel;
var AdvertisementMarkAsSeenRequestModel = /** @class */ (function () {
    function AdvertisementMarkAsSeenRequestModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdvertisementMarkAsSeenRequestModel.prototype.init = function (data) {
        if (data) {
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : null;
            this.isAdmin = data["isAdmin"] !== undefined ? data["isAdmin"] : null;
        }
    };
    AdvertisementMarkAsSeenRequestModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdvertisementMarkAsSeenRequestModel();
        result.init(data);
        return result;
    };
    AdvertisementMarkAsSeenRequestModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : null;
        return data;
    };
    AdvertisementMarkAsSeenRequestModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdvertisementMarkAsSeenRequestModel();
        result.init(json);
        return result;
    };
    return AdvertisementMarkAsSeenRequestModel;
}());
exports.AdvertisementMarkAsSeenRequestModel = AdvertisementMarkAsSeenRequestModel;
var DTOBaseModel = /** @class */ (function () {
    function DTOBaseModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DTOBaseModel.prototype.init = function (data) {
    };
    DTOBaseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOBaseModel();
        result.init(data);
        return result;
    };
    DTOBaseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        return data;
    };
    DTOBaseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOBaseModel();
        result.init(json);
        return result;
    };
    return DTOBaseModel;
}());
exports.DTOBaseModel = DTOBaseModel;
var DTOAdvertisementCategory = /** @class */ (function (_super) {
    __extends(DTOAdvertisementCategory, _super);
    function DTOAdvertisementCategory(data) {
        return _super.call(this, data) || this;
    }
    DTOAdvertisementCategory.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.advertisementCategoryId = data["advertisementCategoryId"] !== undefined ? data["advertisementCategoryId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : null;
            this.casualDating = data["casualDating"] !== undefined ? data["casualDating"] : null;
        }
    };
    DTOAdvertisementCategory.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOAdvertisementCategory();
        result.init(data);
        return result;
    };
    DTOAdvertisementCategory.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    DTOAdvertisementCategory.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOAdvertisementCategory();
        result.init(json);
        return result;
    };
    return DTOAdvertisementCategory;
}(DTOBaseModel));
exports.DTOAdvertisementCategory = DTOAdvertisementCategory;
var DTORegion = /** @class */ (function (_super) {
    __extends(DTORegion, _super);
    function DTORegion(data) {
        return _super.call(this, data) || this;
    }
    DTORegion.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : null;
            this.shortName = data["shortName"] !== undefined ? data["shortName"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : null;
            if (Array.isArray(data["subRegions"])) {
                this.subRegions = [];
                for (var _i = 0, _a = data["subRegions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.subRegions.push(DTOSubRegion.fromJS(item));
                }
            }
        }
    };
    DTORegion.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTORegion();
        result.init(data);
        return result;
    };
    DTORegion.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null;
        if (Array.isArray(this.subRegions)) {
            data["subRegions"] = [];
            for (var _i = 0, _a = this.subRegions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["subRegions"].push(item.toJSON());
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    DTORegion.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTORegion();
        result.init(json);
        return result;
    };
    return DTORegion;
}(DTOBaseModel));
exports.DTORegion = DTORegion;
var DTOSubRegion = /** @class */ (function (_super) {
    __extends(DTOSubRegion, _super);
    function DTOSubRegion(data) {
        return _super.call(this, data) || this;
    }
    DTOSubRegion.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.subRegionId = data["subRegionId"] !== undefined ? data["subRegionId"] : null;
            this.shortName = data["shortName"] !== undefined ? data["shortName"] : null;
            this.shortRegionSubregion = data["shortRegionSubregion"] !== undefined ? data["shortRegionSubregion"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : null;
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : null;
            this.zip = data["zip"] !== undefined ? data["zip"] : null;
        }
    };
    DTOSubRegion.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOSubRegion();
        result.init(data);
        return result;
    };
    DTOSubRegion.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : null;
        data["shortRegionSubregion"] = this.shortRegionSubregion !== undefined ? this.shortRegionSubregion : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["zip"] = this.zip !== undefined ? this.zip : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    DTOSubRegion.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOSubRegion();
        result.init(json);
        return result;
    };
    return DTOSubRegion;
}(DTOBaseModel));
exports.DTOSubRegion = DTOSubRegion;
var AdvertistmentRepostResponse = /** @class */ (function (_super) {
    __extends(AdvertistmentRepostResponse, _super);
    function AdvertistmentRepostResponse(data) {
        return _super.call(this, data) || this;
    }
    AdvertistmentRepostResponse.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.isReposted = data["isReposted"] !== undefined ? data["isReposted"] : null;
        }
    };
    AdvertistmentRepostResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdvertistmentRepostResponse();
        result.init(data);
        return result;
    };
    AdvertistmentRepostResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isReposted"] = this.isReposted !== undefined ? this.isReposted : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdvertistmentRepostResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdvertistmentRepostResponse();
        result.init(json);
        return result;
    };
    return AdvertistmentRepostResponse;
}(ResponseBaseModel));
exports.AdvertistmentRepostResponse = AdvertistmentRepostResponse;
var DTOAdvertisement = /** @class */ (function (_super) {
    __extends(DTOAdvertisement, _super);
    function DTOAdvertisement(data) {
        return _super.call(this, data) || this;
    }
    DTOAdvertisement.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : null;
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : null;
            this.seen = data["seen"] !== undefined ? data["seen"] : null;
            this.seenAdmin = data["seenAdmin"] !== undefined ? data["seenAdmin"] : null;
            this.subRegionId = data["subRegionId"] !== undefined ? data["subRegionId"] : null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : null;
            this.location = data["location"] !== undefined ? data["location"] : null;
            this.dateStart = data["dateStart"] ? moment(data["dateStart"].toString()) : null;
            this.dateEnd = data["dateEnd"] ? moment(data["dateEnd"].toString()) : null;
            this.title = data["title"] !== undefined ? data["title"] : null;
            this.content = data["content"] !== undefined ? data["content"] : null;
            this.published = data["published"] !== undefined ? data["published"] : null;
            this.casualDating = data["casualDating"] !== undefined ? data["casualDating"] : null;
            this.advertisementCategoryId = data["advertisementCategoryId"] !== undefined ? data["advertisementCategoryId"] : null;
            this.isPremium = data["isPremium"] !== undefined ? data["isPremium"] : null;
            this.isPremiumUser = data["isPremiumUser"] !== undefined ? data["isPremiumUser"] : null;
            this.isThirdParty = data["isThirdParty"] !== undefined ? data["isThirdParty"] : null;
            this.regionName = data["regionName"] !== undefined ? data["regionName"] : null;
            this.regionShortName = data["regionShortName"] !== undefined ? data["regionShortName"] : null;
            this.subRegionName = data["subRegionName"] !== undefined ? data["subRegionName"] : null;
            this.categoryCode = data["categoryCode"] !== undefined ? data["categoryCode"] : null;
            if (Array.isArray(data["images"])) {
                this.images = [];
                for (var _i = 0, _a = data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(DTOAdvertisementImage.fromJS(item));
                }
            }
            this.userId = data["userId"] !== undefined ? data["userId"] : null;
            this.userNick = data["userNick"] !== undefined ? data["userNick"] : null;
            this.moderated = data["moderated"] !== undefined ? data["moderated"] : null;
            this.moderatedAt = data["moderatedAt"] ? moment(data["moderatedAt"].toString()) : null;
            this.moderatedBy = data["moderatedBy"] !== undefined ? data["moderatedBy"] : null;
            this.moderateText = data["moderateText"] !== undefined ? data["moderateText"] : null;
            this.age = data["age"] !== undefined ? data["age"] : null;
            this.locationDescription = data["locationDescription"] !== undefined ? data["locationDescription"] : null;
            this.isDemo = data["isDemo"] !== undefined ? data["isDemo"] : null;
            this.showAs = data["showAs"] !== undefined ? data["showAs"] : null;
        }
    };
    DTOAdvertisement.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOAdvertisement();
        result.init(data);
        return result;
    };
    DTOAdvertisement.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["seen"] = this.seen !== undefined ? this.seen : null;
        data["seenAdmin"] = this.seenAdmin !== undefined ? this.seenAdmin : null;
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["location"] = this.location !== undefined ? this.location : null;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : null;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["content"] = this.content !== undefined ? this.content : null;
        data["published"] = this.published !== undefined ? this.published : null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : null;
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : null;
        data["isPremium"] = this.isPremium !== undefined ? this.isPremium : null;
        data["isPremiumUser"] = this.isPremiumUser !== undefined ? this.isPremiumUser : null;
        data["isThirdParty"] = this.isThirdParty !== undefined ? this.isThirdParty : null;
        data["regionName"] = this.regionName !== undefined ? this.regionName : null;
        data["regionShortName"] = this.regionShortName !== undefined ? this.regionShortName : null;
        data["subRegionName"] = this.subRegionName !== undefined ? this.subRegionName : null;
        data["categoryCode"] = this.categoryCode !== undefined ? this.categoryCode : null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["userNick"] = this.userNick !== undefined ? this.userNick : null;
        data["moderated"] = this.moderated !== undefined ? this.moderated : null;
        data["moderatedAt"] = this.moderatedAt ? this.moderatedAt.toISOString() : null;
        data["moderatedBy"] = this.moderatedBy !== undefined ? this.moderatedBy : null;
        data["moderateText"] = this.moderateText !== undefined ? this.moderateText : null;
        data["age"] = this.age !== undefined ? this.age : null;
        data["locationDescription"] = this.locationDescription !== undefined ? this.locationDescription : null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : null;
        data["showAs"] = this.showAs !== undefined ? this.showAs : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    DTOAdvertisement.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOAdvertisement();
        result.init(json);
        return result;
    };
    return DTOAdvertisement;
}(DTOBaseModel));
exports.DTOAdvertisement = DTOAdvertisement;
var AdveristmentCreateModel = /** @class */ (function (_super) {
    __extends(AdveristmentCreateModel, _super);
    function AdveristmentCreateModel(data) {
        return _super.call(this, data) || this;
    }
    AdveristmentCreateModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
    };
    AdveristmentCreateModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentCreateModel();
        result.init(data);
        return result;
    };
    AdveristmentCreateModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdveristmentCreateModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentCreateModel();
        result.init(json);
        return result;
    };
    return AdveristmentCreateModel;
}(DTOAdvertisement));
exports.AdveristmentCreateModel = AdveristmentCreateModel;
var AdveristmentUpdateModel = /** @class */ (function (_super) {
    __extends(AdveristmentUpdateModel, _super);
    function AdveristmentUpdateModel(data) {
        return _super.call(this, data) || this;
    }
    AdveristmentUpdateModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.manageId = data["manageId"] !== undefined ? data["manageId"] : null;
        }
    };
    AdveristmentUpdateModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentUpdateModel();
        result.init(data);
        return result;
    };
    AdveristmentUpdateModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["manageId"] = this.manageId !== undefined ? this.manageId : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdveristmentUpdateModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentUpdateModel();
        result.init(json);
        return result;
    };
    return AdveristmentUpdateModel;
}(AdveristmentCreateModel));
exports.AdveristmentUpdateModel = AdveristmentUpdateModel;
var AdvertistmentRepostModel = /** @class */ (function (_super) {
    __extends(AdvertistmentRepostModel, _super);
    function AdvertistmentRepostModel(data) {
        return _super.call(this, data) || this;
    }
    AdvertistmentRepostModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
    };
    AdvertistmentRepostModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdvertistmentRepostModel();
        result.init(data);
        return result;
    };
    AdvertistmentRepostModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdvertistmentRepostModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdvertistmentRepostModel();
        result.init(json);
        return result;
    };
    return AdvertistmentRepostModel;
}(AdveristmentUpdateModel));
exports.AdvertistmentRepostModel = AdvertistmentRepostModel;
var DTOAdvertisementImage = /** @class */ (function (_super) {
    __extends(DTOAdvertisementImage, _super);
    function DTOAdvertisementImage(data) {
        return _super.call(this, data) || this;
    }
    DTOAdvertisementImage.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.advertisementImageId = data["advertisementImageId"] !== undefined ? data["advertisementImageId"] : null;
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null;
            this.orgFileName = data["orgFileName"] !== undefined ? data["orgFileName"] : null;
            this.tempFileName = data["tempFileName"] !== undefined ? data["tempFileName"] : null;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : null;
            this.isMain = data["isMain"] !== undefined ? data["isMain"] : null;
        }
    };
    DTOAdvertisementImage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOAdvertisementImage();
        result.init(data);
        return result;
    };
    DTOAdvertisementImage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementImageId"] = this.advertisementImageId !== undefined ? this.advertisementImageId : null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["orgFileName"] = this.orgFileName !== undefined ? this.orgFileName : null;
        data["tempFileName"] = this.tempFileName !== undefined ? this.tempFileName : null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : null;
        data["isMain"] = this.isMain !== undefined ? this.isMain : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    DTOAdvertisementImage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOAdvertisementImage();
        result.init(json);
        return result;
    };
    return DTOAdvertisementImage;
}(DTOBaseModel));
exports.DTOAdvertisementImage = DTOAdvertisementImage;
var ShowAdType;
(function (ShowAdType) {
    ShowAdType[ShowAdType["NotSet"] = 0] = "NotSet";
    ShowAdType[ShowAdType["PremiumAd"] = 1] = "PremiumAd";
    ShowAdType[ShowAdType["PremiumUser"] = 2] = "PremiumUser";
    ShowAdType[ShowAdType["StandardAd"] = 3] = "StandardAd";
    ShowAdType[ShowAdType["ThirdParty"] = 4] = "ThirdParty";
})(ShowAdType = exports.ShowAdType || (exports.ShowAdType = {}));
var AdveristmentCreateResponse = /** @class */ (function (_super) {
    __extends(AdveristmentCreateResponse, _super);
    function AdveristmentCreateResponse(data) {
        return _super.call(this, data) || this;
    }
    AdveristmentCreateResponse.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : null;
        }
    };
    AdveristmentCreateResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentCreateResponse();
        result.init(data);
        return result;
    };
    AdveristmentCreateResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdveristmentCreateResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentCreateResponse();
        result.init(json);
        return result;
    };
    return AdveristmentCreateResponse;
}(ResponseBaseModel));
exports.AdveristmentCreateResponse = AdveristmentCreateResponse;
var AdveristmentUpdateResponse = /** @class */ (function (_super) {
    __extends(AdveristmentUpdateResponse, _super);
    function AdveristmentUpdateResponse(data) {
        return _super.call(this, data) || this;
    }
    AdveristmentUpdateResponse.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
    };
    AdveristmentUpdateResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentUpdateResponse();
        result.init(data);
        return result;
    };
    AdveristmentUpdateResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdveristmentUpdateResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentUpdateResponse();
        result.init(json);
        return result;
    };
    return AdveristmentUpdateResponse;
}(AdveristmentCreateResponse));
exports.AdveristmentUpdateResponse = AdveristmentUpdateResponse;
var AdveristmentDeleteResponse = /** @class */ (function (_super) {
    __extends(AdveristmentDeleteResponse, _super);
    function AdveristmentDeleteResponse(data) {
        return _super.call(this, data) || this;
    }
    AdveristmentDeleteResponse.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
    };
    AdveristmentDeleteResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentDeleteResponse();
        result.init(data);
        return result;
    };
    AdveristmentDeleteResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdveristmentDeleteResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentDeleteResponse();
        result.init(json);
        return result;
    };
    return AdveristmentDeleteResponse;
}(AdveristmentCreateResponse));
exports.AdveristmentDeleteResponse = AdveristmentDeleteResponse;
var AdveristmentDeleteModel = /** @class */ (function () {
    function AdveristmentDeleteModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdveristmentDeleteModel.prototype.init = function (data) {
        if (data) {
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : null;
        }
    };
    AdveristmentDeleteModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentDeleteModel();
        result.init(data);
        return result;
    };
    AdveristmentDeleteModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        return data;
    };
    AdveristmentDeleteModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentDeleteModel();
        result.init(json);
        return result;
    };
    return AdveristmentDeleteModel;
}());
exports.AdveristmentDeleteModel = AdveristmentDeleteModel;
var AdveristmentGetResponse = /** @class */ (function (_super) {
    __extends(AdveristmentGetResponse, _super);
    function AdveristmentGetResponse(data) {
        return _super.call(this, data) || this;
    }
    AdveristmentGetResponse.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            if (Array.isArray(data["adveristments"])) {
                this.adveristments = [];
                for (var _i = 0, _a = data["adveristments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.adveristments.push(DTOAdvertisement.fromJS(item));
                }
            }
            this.totalResultsCount = data["totalResultsCount"] !== undefined ? data["totalResultsCount"] : null;
            this.regionShortName = data["regionShortName"] !== undefined ? data["regionShortName"] : null;
            this.subRegionName = data["subRegionName"] !== undefined ? data["subRegionName"] : null;
            this.closestSubregionNameIfNoResult = data["closestSubregionNameIfNoResult"] !== undefined ? data["closestSubregionNameIfNoResult"] : null;
        }
    };
    AdveristmentGetResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentGetResponse();
        result.init(data);
        return result;
    };
    AdveristmentGetResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.adveristments)) {
            data["adveristments"] = [];
            for (var _i = 0, _a = this.adveristments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["adveristments"].push(item.toJSON());
            }
        }
        data["totalResultsCount"] = this.totalResultsCount !== undefined ? this.totalResultsCount : null;
        data["regionShortName"] = this.regionShortName !== undefined ? this.regionShortName : null;
        data["subRegionName"] = this.subRegionName !== undefined ? this.subRegionName : null;
        data["closestSubregionNameIfNoResult"] = this.closestSubregionNameIfNoResult !== undefined ? this.closestSubregionNameIfNoResult : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdveristmentGetResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentGetResponse();
        result.init(json);
        return result;
    };
    return AdveristmentGetResponse;
}(ResponseBaseModel));
exports.AdveristmentGetResponse = AdveristmentGetResponse;
var AdveristmentGetModel = /** @class */ (function () {
    function AdveristmentGetModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdveristmentGetModel.prototype.init = function (data) {
        if (data) {
            this.conversationKey = data["conversationKey"] !== undefined ? data["conversationKey"] : null;
            this.byId = data["byId"] !== undefined ? data["byId"] : null;
            this.userId = data["userId"] !== undefined ? data["userId"] : null;
            this.pageNumber = data["pageNumber"] !== undefined ? data["pageNumber"] : null;
            this.pageSize = data["pageSize"] !== undefined ? data["pageSize"] : null;
            this.nonDemoOnly = data["nonDemoOnly"] !== undefined ? data["nonDemoOnly"] : null;
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : null;
            this.subRegionId = data["subRegionId"] !== undefined ? data["subRegionId"] : null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : null;
            this.miles = data["miles"] !== undefined ? data["miles"] : null;
            this.keywords = data["keywords"] !== undefined ? data["keywords"] : null;
            this.withPicturesOnly = data["withPicturesOnly"] !== undefined ? data["withPicturesOnly"] : null;
            this.showActive = data["showActive"] !== undefined ? data["showActive"] : null;
            this.showExpired = data["showExpired"] !== undefined ? data["showExpired"] : null;
            this.casualDating = data["casualDating"] !== undefined ? data["casualDating"] : null;
            this.advertisementCategoryId = data["advertisementCategoryId"] !== undefined ? data["advertisementCategoryId"] : null;
            this.title = data["title"] !== undefined ? data["title"] : null;
            this.content = data["content"] !== undefined ? data["content"] : null;
            this.manageId = data["manageId"] !== undefined ? data["manageId"] : null;
            this.age = data["age"] !== undefined ? data["age"] : null;
            this.locationDescription = data["locationDescription"] !== undefined ? data["locationDescription"] : null;
        }
    };
    AdveristmentGetModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentGetModel();
        result.init(data);
        return result;
    };
    AdveristmentGetModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationKey"] = this.conversationKey !== undefined ? this.conversationKey : null;
        data["byId"] = this.byId !== undefined ? this.byId : null;
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["nonDemoOnly"] = this.nonDemoOnly !== undefined ? this.nonDemoOnly : null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["miles"] = this.miles !== undefined ? this.miles : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["withPicturesOnly"] = this.withPicturesOnly !== undefined ? this.withPicturesOnly : null;
        data["showActive"] = this.showActive !== undefined ? this.showActive : null;
        data["showExpired"] = this.showExpired !== undefined ? this.showExpired : null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : null;
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["content"] = this.content !== undefined ? this.content : null;
        data["manageId"] = this.manageId !== undefined ? this.manageId : null;
        data["age"] = this.age !== undefined ? this.age : null;
        data["locationDescription"] = this.locationDescription !== undefined ? this.locationDescription : null;
        return data;
    };
    AdveristmentGetModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentGetModel();
        result.init(json);
        return result;
    };
    return AdveristmentGetModel;
}());
exports.AdveristmentGetModel = AdveristmentGetModel;
var GetAdvertisementsRequest = /** @class */ (function () {
    function GetAdvertisementsRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAdvertisementsRequest.prototype.init = function (data) {
        if (data) {
            this.casualDating = data["casualDating"] !== undefined ? data["casualDating"] : null;
            this.relationShip = data["relationShip"] !== undefined ? data["relationShip"] : null;
            this.withPicture = data["withPicture"] !== undefined ? data["withPicture"] : null;
            this.state = data["state"] !== undefined ? data["state"] : null;
            this.city = data["city"] !== undefined ? data["city"] : null;
            this.page = data["page"] !== undefined ? data["page"] : null;
        }
    };
    GetAdvertisementsRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAdvertisementsRequest();
        result.init(data);
        return result;
    };
    GetAdvertisementsRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : null;
        data["relationShip"] = this.relationShip !== undefined ? this.relationShip : null;
        data["withPicture"] = this.withPicture !== undefined ? this.withPicture : null;
        data["state"] = this.state !== undefined ? this.state : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["page"] = this.page !== undefined ? this.page : null;
        return data;
    };
    GetAdvertisementsRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new GetAdvertisementsRequest();
        result.init(json);
        return result;
    };
    return GetAdvertisementsRequest;
}());
exports.GetAdvertisementsRequest = GetAdvertisementsRequest;
var SearchParamsResponse = /** @class */ (function () {
    function SearchParamsResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SearchParamsResponse.prototype.init = function (data) {
        if (data) {
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : null;
            this.subregionId = data["subregionId"] !== undefined ? data["subregionId"] : null;
            this.categoryId = data["categoryId"] !== undefined ? data["categoryId"] : null;
            this.casualDating = data["casualDating"] !== undefined ? data["casualDating"] : null;
            this.withPicture = data["withPicture"] !== undefined ? data["withPicture"] : null;
            this.isValid = data["isValid"] !== undefined ? data["isValid"] : null;
        }
    };
    SearchParamsResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SearchParamsResponse();
        result.init(data);
        return result;
    };
    SearchParamsResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["subregionId"] = this.subregionId !== undefined ? this.subregionId : null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : null;
        data["withPicture"] = this.withPicture !== undefined ? this.withPicture : null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : null;
        return data;
    };
    SearchParamsResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SearchParamsResponse();
        result.init(json);
        return result;
    };
    return SearchParamsResponse;
}());
exports.SearchParamsResponse = SearchParamsResponse;
var SearchParamsRequest = /** @class */ (function () {
    function SearchParamsRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SearchParamsRequest.prototype.init = function (data) {
        if (data) {
            this.state = data["state"] !== undefined ? data["state"] : null;
            this.city = data["city"] !== undefined ? data["city"] : null;
            this.category = data["category"] !== undefined ? data["category"] : null;
            this.type = data["type"] !== undefined ? data["type"] : null;
            this.withPicture = data["withPicture"] !== undefined ? data["withPicture"] : null;
        }
    };
    SearchParamsRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SearchParamsRequest();
        result.init(data);
        return result;
    };
    SearchParamsRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state !== undefined ? this.state : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["category"] = this.category !== undefined ? this.category : null;
        data["type"] = this.type !== undefined ? this.type : null;
        data["withPicture"] = this.withPicture !== undefined ? this.withPicture : null;
        return data;
    };
    SearchParamsRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SearchParamsRequest();
        result.init(json);
        return result;
    };
    return SearchParamsRequest;
}());
exports.SearchParamsRequest = SearchParamsRequest;
var AdWritterInformationResponse = /** @class */ (function (_super) {
    __extends(AdWritterInformationResponse, _super);
    function AdWritterInformationResponse(data) {
        return _super.call(this, data) || this;
    }
    AdWritterInformationResponse.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.isSend = data["isSend"] !== undefined ? data["isSend"] : null;
        }
    };
    AdWritterInformationResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdWritterInformationResponse();
        result.init(data);
        return result;
    };
    AdWritterInformationResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isSend"] = this.isSend !== undefined ? this.isSend : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdWritterInformationResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdWritterInformationResponse();
        result.init(json);
        return result;
    };
    return AdWritterInformationResponse;
}(ResponseBaseModel));
exports.AdWritterInformationResponse = AdWritterInformationResponse;
var AdWritterInformationRequest = /** @class */ (function () {
    function AdWritterInformationRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdWritterInformationRequest.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.age = data["age"] !== undefined ? data["age"] : null;
            this.gender = data["gender"] !== undefined ? data["gender"] : null;
            this.lookingFor = data["lookingFor"] !== undefined ? data["lookingFor"] : null;
            this.height = data["height"] !== undefined ? data["height"] : null;
            this.weight = data["weight"] !== undefined ? data["weight"] : null;
            this.bodyType = data["bodyType"] !== undefined ? data["bodyType"] : null;
            this.race = data["race"] !== undefined ? data["race"] : null;
            this.idealMatch = data["idealMatch"] !== undefined ? data["idealMatch"] : null;
            this.lookingForRelationship = data["lookingForRelationship"] !== undefined ? data["lookingForRelationship"] : null;
            this.thingsInFreeTime = data["thingsInFreeTime"] !== undefined ? data["thingsInFreeTime"] : null;
            this.aspectsOfLife = data["aspectsOfLife"] !== undefined ? data["aspectsOfLife"] : null;
            this.dontLike = data["dontLike"] !== undefined ? data["dontLike"] : null;
            this.passions = data["passions"] !== undefined ? data["passions"] : null;
            this.occupation = data["occupation"] !== undefined ? data["occupation"] : null;
            this.characteristics = data["characteristics"] !== undefined ? data["characteristics"] : null;
            this.goalsAndDreams = data["goalsAndDreams"] !== undefined ? data["goalsAndDreams"] : null;
            this.thankfullFor = data["thankfullFor"] !== undefined ? data["thankfullFor"] : null;
            this.kids = data["kids"] !== undefined ? data["kids"] : null;
            this.education = data["education"] !== undefined ? data["education"] : null;
            this.workout = data["workout"] !== undefined ? data["workout"] : null;
            this.travel = data["travel"] !== undefined ? data["travel"] : null;
            this.healthyFood = data["healthyFood"] !== undefined ? data["healthyFood"] : null;
            this.smoke = data["smoke"] !== undefined ? data["smoke"] : null;
            this.alcohol = data["alcohol"] !== undefined ? data["alcohol"] : null;
            this.email = data["email"] !== undefined ? data["email"] : null;
        }
    };
    AdWritterInformationRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdWritterInformationRequest();
        result.init(data);
        return result;
    };
    AdWritterInformationRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        data["age"] = this.age !== undefined ? this.age : null;
        data["gender"] = this.gender !== undefined ? this.gender : null;
        data["lookingFor"] = this.lookingFor !== undefined ? this.lookingFor : null;
        data["height"] = this.height !== undefined ? this.height : null;
        data["weight"] = this.weight !== undefined ? this.weight : null;
        data["bodyType"] = this.bodyType !== undefined ? this.bodyType : null;
        data["race"] = this.race !== undefined ? this.race : null;
        data["idealMatch"] = this.idealMatch !== undefined ? this.idealMatch : null;
        data["lookingForRelationship"] = this.lookingForRelationship !== undefined ? this.lookingForRelationship : null;
        data["thingsInFreeTime"] = this.thingsInFreeTime !== undefined ? this.thingsInFreeTime : null;
        data["aspectsOfLife"] = this.aspectsOfLife !== undefined ? this.aspectsOfLife : null;
        data["dontLike"] = this.dontLike !== undefined ? this.dontLike : null;
        data["passions"] = this.passions !== undefined ? this.passions : null;
        data["occupation"] = this.occupation !== undefined ? this.occupation : null;
        data["characteristics"] = this.characteristics !== undefined ? this.characteristics : null;
        data["goalsAndDreams"] = this.goalsAndDreams !== undefined ? this.goalsAndDreams : null;
        data["thankfullFor"] = this.thankfullFor !== undefined ? this.thankfullFor : null;
        data["kids"] = this.kids !== undefined ? this.kids : null;
        data["education"] = this.education !== undefined ? this.education : null;
        data["workout"] = this.workout !== undefined ? this.workout : null;
        data["travel"] = this.travel !== undefined ? this.travel : null;
        data["healthyFood"] = this.healthyFood !== undefined ? this.healthyFood : null;
        data["smoke"] = this.smoke !== undefined ? this.smoke : null;
        data["alcohol"] = this.alcohol !== undefined ? this.alcohol : null;
        data["email"] = this.email !== undefined ? this.email : null;
        return data;
    };
    AdWritterInformationRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdWritterInformationRequest();
        result.init(json);
        return result;
    };
    return AdWritterInformationRequest;
}());
exports.AdWritterInformationRequest = AdWritterInformationRequest;
var LoginResponseModel = /** @class */ (function (_super) {
    __extends(LoginResponseModel, _super);
    function LoginResponseModel(data) {
        return _super.call(this, data) || this;
    }
    LoginResponseModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.token = data["token"] !== undefined ? data["token"] : null;
            this.isDemo = data["isDemo"] !== undefined ? data["isDemo"] : null;
            this.phoneVerificationRequired = data["phoneVerificationRequired"] !== undefined ? data["phoneVerificationRequired"] : null;
            this.userId = data["userId"] !== undefined ? data["userId"] : null;
            this.userPhone = data["userPhone"] !== undefined ? data["userPhone"] : null;
        }
    };
    LoginResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LoginResponseModel();
        result.init(data);
        return result;
    };
    LoginResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : null;
        data["phoneVerificationRequired"] = this.phoneVerificationRequired !== undefined ? this.phoneVerificationRequired : null;
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["userPhone"] = this.userPhone !== undefined ? this.userPhone : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    LoginResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new LoginResponseModel();
        result.init(json);
        return result;
    };
    return LoginResponseModel;
}(ResponseBaseModel));
exports.LoginResponseModel = LoginResponseModel;
var LoginModel = /** @class */ (function () {
    function LoginModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LoginModel.prototype.init = function (data) {
        if (data) {
            this.userName = data["userName"] !== undefined ? data["userName"] : null;
            this.password = data["password"] !== undefined ? data["password"] : null;
        }
    };
    LoginModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LoginModel();
        result.init(data);
        return result;
    };
    LoginModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["password"] = this.password !== undefined ? this.password : null;
        return data;
    };
    LoginModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new LoginModel();
        result.init(json);
        return result;
    };
    return LoginModel;
}());
exports.LoginModel = LoginModel;
var Baners = /** @class */ (function () {
    function Baners(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.status = BanerStatus.Active;
        }
    }
    Baners.prototype.init = function (data) {
        if (data) {
            this.banerId = data["banerId"] !== undefined ? data["banerId"] : null;
            this.createdAt = data["createdAt"] ? moment(data["createdAt"].toString()) : null;
            this.clientDetails = data["clientDetails"] !== undefined ? data["clientDetails"] : null;
            this.banerUrl = data["banerUrl"] !== undefined ? data["banerUrl"] : null;
            this.desktopImageHorizontal = data["desktopImageHorizontal"] !== undefined ? data["desktopImageHorizontal"] : null;
            this.desktopImageVertical = data["desktopImageVertical"] !== undefined ? data["desktopImageVertical"] : null;
            this.mobileImage = data["mobileImage"] !== undefined ? data["mobileImage"] : null;
            this.isMobile = data["isMobile"] !== undefined ? data["isMobile"] : null;
            this.status = data["status"] !== undefined ? data["status"] : BanerStatus.Active;
        }
    };
    Baners.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Baners();
        result.init(data);
        return result;
    };
    Baners.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["banerId"] = this.banerId !== undefined ? this.banerId : null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null;
        data["clientDetails"] = this.clientDetails !== undefined ? this.clientDetails : null;
        data["banerUrl"] = this.banerUrl !== undefined ? this.banerUrl : null;
        data["desktopImageHorizontal"] = this.desktopImageHorizontal !== undefined ? this.desktopImageHorizontal : null;
        data["desktopImageVertical"] = this.desktopImageVertical !== undefined ? this.desktopImageVertical : null;
        data["mobileImage"] = this.mobileImage !== undefined ? this.mobileImage : null;
        data["isMobile"] = this.isMobile !== undefined ? this.isMobile : null;
        data["status"] = this.status !== undefined ? this.status : null;
        return data;
    };
    Baners.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Baners();
        result.init(json);
        return result;
    };
    return Baners;
}());
exports.Baners = Baners;
var BanerStatus;
(function (BanerStatus) {
    BanerStatus[BanerStatus["Active"] = 0] = "Active";
    BanerStatus[BanerStatus["Canceled"] = 1] = "Canceled";
    BanerStatus[BanerStatus["Expired"] = 2] = "Expired";
})(BanerStatus = exports.BanerStatus || (exports.BanerStatus = {}));
var ConversationDeleteResponseModel = /** @class */ (function (_super) {
    __extends(ConversationDeleteResponseModel, _super);
    function ConversationDeleteResponseModel(data) {
        return _super.call(this, data) || this;
    }
    ConversationDeleteResponseModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
    };
    ConversationDeleteResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConversationDeleteResponseModel();
        result.init(data);
        return result;
    };
    ConversationDeleteResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    ConversationDeleteResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ConversationDeleteResponseModel();
        result.init(json);
        return result;
    };
    return ConversationDeleteResponseModel;
}(ResponseBaseModel));
exports.ConversationDeleteResponseModel = ConversationDeleteResponseModel;
var ConversationDeleteRequestModel = /** @class */ (function () {
    function ConversationDeleteRequestModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConversationDeleteRequestModel.prototype.init = function (data) {
        if (data) {
            this.conversationId = data["conversationId"] !== undefined ? data["conversationId"] : null;
        }
    };
    ConversationDeleteRequestModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConversationDeleteRequestModel();
        result.init(data);
        return result;
    };
    ConversationDeleteRequestModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : null;
        return data;
    };
    ConversationDeleteRequestModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ConversationDeleteRequestModel();
        result.init(json);
        return result;
    };
    return ConversationDeleteRequestModel;
}());
exports.ConversationDeleteRequestModel = ConversationDeleteRequestModel;
var GetConversationResponseModel = /** @class */ (function (_super) {
    __extends(GetConversationResponseModel, _super);
    function GetConversationResponseModel(data) {
        return _super.call(this, data) || this;
    }
    GetConversationResponseModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.conversation = data["conversation"] ? DTOConversation.fromJS(data["conversation"]) : null;
        }
    };
    GetConversationResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetConversationResponseModel();
        result.init(data);
        return result;
    };
    GetConversationResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversation"] = this.conversation ? this.conversation.toJSON() : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    GetConversationResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new GetConversationResponseModel();
        result.init(json);
        return result;
    };
    return GetConversationResponseModel;
}(ResponseBaseModel));
exports.GetConversationResponseModel = GetConversationResponseModel;
var DTOConversation = /** @class */ (function () {
    function DTOConversation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DTOConversation.prototype.init = function (data) {
        if (data) {
            this.conversationId = data["conversationId"] !== undefined ? data["conversationId"] : null;
            this.senderId = data["senderId"] !== undefined ? data["senderId"] : null;
            this.receiverId = data["receiverId"] !== undefined ? data["receiverId"] : null;
            this.conversationKey = data["conversationKey"] !== undefined ? data["conversationKey"] : null;
            this.senderNick = data["senderNick"] !== undefined ? data["senderNick"] : null;
            this.creationDate = data["creationDate"] ? moment(data["creationDate"].toString()) : null;
            this.receiverNick = data["receiverNick"] !== undefined ? data["receiverNick"] : null;
            this.advTitle = data["advTitle"] !== undefined ? data["advTitle"] : null;
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : null;
            this.demoAdvertisement = data["demoAdvertisement"] !== undefined ? data["demoAdvertisement"] : null;
            this.hasNewMessages = data["hasNewMessages"] !== undefined ? data["hasNewMessages"] : null;
            this.lastMessageDate = data["lastMessageDate"] ? moment(data["lastMessageDate"].toString()) : null;
            if (Array.isArray(data["messages"])) {
                this.messages = [];
                for (var _i = 0, _a = data["messages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.messages.push(DTOConversationMessage.fromJS(item));
                }
            }
        }
    };
    DTOConversation.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOConversation();
        result.init(data);
        return result;
    };
    DTOConversation.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : null;
        data["receiverId"] = this.receiverId !== undefined ? this.receiverId : null;
        data["conversationKey"] = this.conversationKey !== undefined ? this.conversationKey : null;
        data["senderNick"] = this.senderNick !== undefined ? this.senderNick : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["receiverNick"] = this.receiverNick !== undefined ? this.receiverNick : null;
        data["advTitle"] = this.advTitle !== undefined ? this.advTitle : null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["demoAdvertisement"] = this.demoAdvertisement !== undefined ? this.demoAdvertisement : null;
        data["hasNewMessages"] = this.hasNewMessages !== undefined ? this.hasNewMessages : null;
        data["lastMessageDate"] = this.lastMessageDate ? this.lastMessageDate.toISOString() : null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (var _i = 0, _a = this.messages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["messages"].push(item.toJSON());
            }
        }
        return data;
    };
    DTOConversation.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOConversation();
        result.init(json);
        return result;
    };
    return DTOConversation;
}());
exports.DTOConversation = DTOConversation;
var DTOConversationMessage = /** @class */ (function () {
    function DTOConversationMessage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DTOConversationMessage.prototype.init = function (data) {
        if (data) {
            this.conversationMessageId = data["conversationMessageId"] !== undefined ? data["conversationMessageId"] : null;
            this.content = data["content"] !== undefined ? data["content"] : null;
            this.senderId = data["senderId"] !== undefined ? data["senderId"] : null;
            this.creationDate = data["creationDate"] ? moment(data["creationDate"].toString()) : null;
            this.title = data["title"] !== undefined ? data["title"] : null;
            this.isRead = data["isRead"] !== undefined ? data["isRead"] : null;
            if (Array.isArray(data["images"])) {
                this.images = [];
                for (var _i = 0, _a = data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(DTOConversationImage.fromJS(item));
                }
            }
        }
    };
    DTOConversationMessage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOConversationMessage();
        result.init(data);
        return result;
    };
    DTOConversationMessage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationMessageId"] = this.conversationMessageId !== undefined ? this.conversationMessageId : null;
        data["content"] = this.content !== undefined ? this.content : null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["isRead"] = this.isRead !== undefined ? this.isRead : null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        return data;
    };
    DTOConversationMessage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOConversationMessage();
        result.init(json);
        return result;
    };
    return DTOConversationMessage;
}());
exports.DTOConversationMessage = DTOConversationMessage;
var DTOConversationImage = /** @class */ (function () {
    function DTOConversationImage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DTOConversationImage.prototype.init = function (data) {
        if (data) {
            this.conversationImageId = data["conversationImageId"] !== undefined ? data["conversationImageId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null;
        }
    };
    DTOConversationImage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOConversationImage();
        result.init(data);
        return result;
    };
    DTOConversationImage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationImageId"] = this.conversationImageId !== undefined ? this.conversationImageId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        return data;
    };
    DTOConversationImage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOConversationImage();
        result.init(json);
        return result;
    };
    return DTOConversationImage;
}());
exports.DTOConversationImage = DTOConversationImage;
var UserConversationsResponseModel = /** @class */ (function (_super) {
    __extends(UserConversationsResponseModel, _super);
    function UserConversationsResponseModel(data) {
        return _super.call(this, data) || this;
    }
    UserConversationsResponseModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            if (Array.isArray(data["conversations"])) {
                this.conversations = [];
                for (var _i = 0, _a = data["conversations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.conversations.push(DTOConversation.fromJS(item));
                }
            }
            this.unreadMessagesCount = data["unreadMessagesCount"] !== undefined ? data["unreadMessagesCount"] : null;
            this.page = data["page"] !== undefined ? data["page"] : null;
            this.pageSize = data["pageSize"] !== undefined ? data["pageSize"] : null;
            this.pageCount = data["pageCount"] !== undefined ? data["pageCount"] : null;
        }
    };
    UserConversationsResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserConversationsResponseModel();
        result.init(data);
        return result;
    };
    UserConversationsResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conversations)) {
            data["conversations"] = [];
            for (var _i = 0, _a = this.conversations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["conversations"].push(item.toJSON());
            }
        }
        data["unreadMessagesCount"] = this.unreadMessagesCount !== undefined ? this.unreadMessagesCount : null;
        data["page"] = this.page !== undefined ? this.page : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    UserConversationsResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UserConversationsResponseModel();
        result.init(json);
        return result;
    };
    return UserConversationsResponseModel;
}(ResponseBaseModel));
exports.UserConversationsResponseModel = UserConversationsResponseModel;
var UserConversationsRequestModel = /** @class */ (function () {
    function UserConversationsRequestModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserConversationsRequestModel.prototype.init = function (data) {
    };
    UserConversationsRequestModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserConversationsRequestModel();
        result.init(data);
        return result;
    };
    UserConversationsRequestModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        return data;
    };
    UserConversationsRequestModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UserConversationsRequestModel();
        result.init(json);
        return result;
    };
    return UserConversationsRequestModel;
}());
exports.UserConversationsRequestModel = UserConversationsRequestModel;
var MessageSubmitResponseModel = /** @class */ (function (_super) {
    __extends(MessageSubmitResponseModel, _super);
    function MessageSubmitResponseModel(data) {
        return _super.call(this, data) || this;
    }
    MessageSubmitResponseModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.conversationKey = data["conversationKey"] !== undefined ? data["conversationKey"] : null;
            this.unreadMessagesCount = data["unreadMessagesCount"] !== undefined ? data["unreadMessagesCount"] : null;
            this.page = data["page"] !== undefined ? data["page"] : null;
            this.pageSize = data["pageSize"] !== undefined ? data["pageSize"] : null;
            this.pageCount = data["pageCount"] !== undefined ? data["pageCount"] : null;
        }
    };
    MessageSubmitResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MessageSubmitResponseModel();
        result.init(data);
        return result;
    };
    MessageSubmitResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationKey"] = this.conversationKey !== undefined ? this.conversationKey : null;
        data["unreadMessagesCount"] = this.unreadMessagesCount !== undefined ? this.unreadMessagesCount : null;
        data["page"] = this.page !== undefined ? this.page : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    MessageSubmitResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new MessageSubmitResponseModel();
        result.init(json);
        return result;
    };
    return MessageSubmitResponseModel;
}(ResponseBaseModel));
exports.MessageSubmitResponseModel = MessageSubmitResponseModel;
var BaseMessageSubmitRequestModel = /** @class */ (function () {
    function BaseMessageSubmitRequestModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BaseMessageSubmitRequestModel.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["images"])) {
                this.images = [];
                for (var _i = 0, _a = data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(DTOImage.fromJS(item));
                }
            }
            this.content = data["content"] !== undefined ? data["content"] : null;
        }
    };
    BaseMessageSubmitRequestModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BaseMessageSubmitRequestModel();
        result.init(data);
        return result;
    };
    BaseMessageSubmitRequestModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        data["content"] = this.content !== undefined ? this.content : null;
        return data;
    };
    BaseMessageSubmitRequestModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new BaseMessageSubmitRequestModel();
        result.init(json);
        return result;
    };
    return BaseMessageSubmitRequestModel;
}());
exports.BaseMessageSubmitRequestModel = BaseMessageSubmitRequestModel;
var ConversationMessageSubmitRequestModel = /** @class */ (function (_super) {
    __extends(ConversationMessageSubmitRequestModel, _super);
    function ConversationMessageSubmitRequestModel(data) {
        return _super.call(this, data) || this;
    }
    ConversationMessageSubmitRequestModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.conversationId = data["conversationId"] !== undefined ? data["conversationId"] : null;
            this.senderId = data["senderId"] !== undefined ? data["senderId"] : null;
        }
    };
    ConversationMessageSubmitRequestModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConversationMessageSubmitRequestModel();
        result.init(data);
        return result;
    };
    ConversationMessageSubmitRequestModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    ConversationMessageSubmitRequestModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ConversationMessageSubmitRequestModel();
        result.init(json);
        return result;
    };
    return ConversationMessageSubmitRequestModel;
}(BaseMessageSubmitRequestModel));
exports.ConversationMessageSubmitRequestModel = ConversationMessageSubmitRequestModel;
var DTOImage = /** @class */ (function (_super) {
    __extends(DTOImage, _super);
    function DTOImage(data) {
        return _super.call(this, data) || this;
    }
    DTOImage.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null;
            this.orgFileName = data["orgFileName"] !== undefined ? data["orgFileName"] : null;
        }
    };
    DTOImage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOImage();
        result.init(data);
        return result;
    };
    DTOImage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["orgFileName"] = this.orgFileName !== undefined ? this.orgFileName : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    DTOImage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOImage();
        result.init(json);
        return result;
    };
    return DTOImage;
}(DTOBaseModel));
exports.DTOImage = DTOImage;
var StartConversationMessageSubmitRequestModel = /** @class */ (function (_super) {
    __extends(StartConversationMessageSubmitRequestModel, _super);
    function StartConversationMessageSubmitRequestModel(data) {
        return _super.call(this, data) || this;
    }
    StartConversationMessageSubmitRequestModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.receiverId = data["receiverId"] !== undefined ? data["receiverId"] : null;
            this.senderId = data["senderId"] !== undefined ? data["senderId"] : null;
            this.senderNick = data["senderNick"] !== undefined ? data["senderNick"] : null;
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : null;
            this.additionalInformations = data["additionalInformations"] ? ConversationAdditionalInformations.fromJS(data["additionalInformations"]) : null;
        }
    };
    StartConversationMessageSubmitRequestModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StartConversationMessageSubmitRequestModel();
        result.init(data);
        return result;
    };
    StartConversationMessageSubmitRequestModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["receiverId"] = this.receiverId !== undefined ? this.receiverId : null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : null;
        data["senderNick"] = this.senderNick !== undefined ? this.senderNick : null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["additionalInformations"] = this.additionalInformations ? this.additionalInformations.toJSON() : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    StartConversationMessageSubmitRequestModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new StartConversationMessageSubmitRequestModel();
        result.init(json);
        return result;
    };
    return StartConversationMessageSubmitRequestModel;
}(BaseMessageSubmitRequestModel));
exports.StartConversationMessageSubmitRequestModel = StartConversationMessageSubmitRequestModel;
var ConversationAdditionalInformations = /** @class */ (function () {
    function ConversationAdditionalInformations(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConversationAdditionalInformations.prototype.init = function (data) {
        if (data) {
            this.advertisementData = data["advertisementData"] ? moment(data["advertisementData"].toString()) : null;
            this.subregionName = data["subregionName"] !== undefined ? data["subregionName"] : null;
            this.regionShortName = data["regionShortName"] !== undefined ? data["regionShortName"] : null;
        }
    };
    ConversationAdditionalInformations.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConversationAdditionalInformations();
        result.init(data);
        return result;
    };
    ConversationAdditionalInformations.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementData"] = this.advertisementData ? this.advertisementData.toISOString() : null;
        data["subregionName"] = this.subregionName !== undefined ? this.subregionName : null;
        data["regionShortName"] = this.regionShortName !== undefined ? this.regionShortName : null;
        return data;
    };
    ConversationAdditionalInformations.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ConversationAdditionalInformations();
        result.init(json);
        return result;
    };
    return ConversationAdditionalInformations;
}());
exports.ConversationAdditionalInformations = ConversationAdditionalInformations;
var EmojiResponseModel = /** @class */ (function (_super) {
    __extends(EmojiResponseModel, _super);
    function EmojiResponseModel(data) {
        return _super.call(this, data) || this;
    }
    EmojiResponseModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            if (Array.isArray(data["emojis"])) {
                this.emojis = [];
                for (var _i = 0, _a = data["emojis"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.emojis.push(DTOEmoji.fromJS(item));
                }
            }
        }
    };
    EmojiResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EmojiResponseModel();
        result.init(data);
        return result;
    };
    EmojiResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emojis)) {
            data["emojis"] = [];
            for (var _i = 0, _a = this.emojis; _i < _a.length; _i++) {
                var item = _a[_i];
                data["emojis"].push(item.toJSON());
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    EmojiResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new EmojiResponseModel();
        result.init(json);
        return result;
    };
    return EmojiResponseModel;
}(ResponseBaseModel));
exports.EmojiResponseModel = EmojiResponseModel;
var DTOEmoji = /** @class */ (function () {
    function DTOEmoji(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DTOEmoji.prototype.init = function (data) {
        if (data) {
            this.emojiId = data["emojiId"] !== undefined ? data["emojiId"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.title = data["title"] !== undefined ? data["title"] : null;
            this.category = data["category"] !== undefined ? data["category"] : null;
        }
    };
    DTOEmoji.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOEmoji();
        result.init(data);
        return result;
    };
    DTOEmoji.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["emojiId"] = this.emojiId !== undefined ? this.emojiId : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["category"] = this.category !== undefined ? this.category : null;
        return data;
    };
    DTOEmoji.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOEmoji();
        result.init(json);
        return result;
    };
    return DTOEmoji;
}());
exports.DTOEmoji = DTOEmoji;
var BaseModel = /** @class */ (function () {
    function BaseModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BaseModel.prototype.init = function (data) {
        if (data) {
            this.createdAt = data["createdAt"] ? moment(data["createdAt"].toString()) : null;
            this.updatedAt = data["updatedAt"] ? moment(data["updatedAt"].toString()) : null;
            this.createdById = data["createdById"] !== undefined ? data["createdById"] : null;
            this.updatedById = data["updatedById"] !== undefined ? data["updatedById"] : null;
        }
    };
    BaseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BaseModel();
        result.init(data);
        return result;
    };
    BaseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : null;
        data["createdById"] = this.createdById !== undefined ? this.createdById : null;
        data["updatedById"] = this.updatedById !== undefined ? this.updatedById : null;
        return data;
    };
    BaseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new BaseModel();
        result.init(json);
        return result;
    };
    return BaseModel;
}());
exports.BaseModel = BaseModel;
var SubRegion = /** @class */ (function (_super) {
    __extends(SubRegion, _super);
    function SubRegion(data) {
        return _super.call(this, data) || this;
    }
    SubRegion.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.subRegionId = data["subRegionId"] !== undefined ? data["subRegionId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.zip = data["zip"] !== undefined ? data["zip"] : null;
            this.latitude = data["latitude"] !== undefined ? data["latitude"] : null;
            this.longitude = data["longitude"] !== undefined ? data["longitude"] : null;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : null;
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : null;
            this.demoQuantityRatio = data["demoQuantityRatio"] !== undefined ? data["demoQuantityRatio"] : null;
            this.population = data["population"] !== undefined ? data["population"] : null;
            this.region = data["region"] ? Region.fromJS(data["region"]) : null;
            if (Array.isArray(data["advertisements"])) {
                this.advertisements = [];
                for (var _i = 0, _a = data["advertisements"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.advertisements.push(Advertisement.fromJS(item));
                }
            }
        }
    };
    SubRegion.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubRegion();
        result.init(data);
        return result;
    };
    SubRegion.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["zip"] = this.zip !== undefined ? this.zip : null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["demoQuantityRatio"] = this.demoQuantityRatio !== undefined ? this.demoQuantityRatio : null;
        data["population"] = this.population !== undefined ? this.population : null;
        data["region"] = this.region ? this.region.toJSON() : null;
        if (Array.isArray(this.advertisements)) {
            data["advertisements"] = [];
            for (var _i = 0, _a = this.advertisements; _i < _a.length; _i++) {
                var item = _a[_i];
                data["advertisements"].push(item.toJSON());
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    SubRegion.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SubRegion();
        result.init(json);
        return result;
    };
    return SubRegion;
}(BaseModel));
exports.SubRegion = SubRegion;
var Region = /** @class */ (function (_super) {
    __extends(Region, _super);
    function Region(data) {
        return _super.call(this, data) || this;
    }
    Region.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : null;
            this.shortName = data["shortName"] !== undefined ? data["shortName"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : null;
            if (Array.isArray(data["subRegions"])) {
                this.subRegions = [];
                for (var _i = 0, _a = data["subRegions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.subRegions.push(SubRegion.fromJS(item));
                }
            }
            if (Array.isArray(data["advertisements"])) {
                this.advertisements = [];
                for (var _b = 0, _c = data["advertisements"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.advertisements.push(Advertisement.fromJS(item));
                }
            }
        }
    };
    Region.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Region();
        result.init(data);
        return result;
    };
    Region.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null;
        if (Array.isArray(this.subRegions)) {
            data["subRegions"] = [];
            for (var _i = 0, _a = this.subRegions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["subRegions"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.advertisements)) {
            data["advertisements"] = [];
            for (var _b = 0, _c = this.advertisements; _b < _c.length; _b++) {
                var item = _c[_b];
                data["advertisements"].push(item.toJSON());
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    Region.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Region();
        result.init(json);
        return result;
    };
    return Region;
}(BaseModel));
exports.Region = Region;
var Advertisement = /** @class */ (function (_super) {
    __extends(Advertisement, _super);
    function Advertisement(data) {
        return _super.call(this, data) || this;
    }
    Advertisement.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : null;
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : null;
            this.subRegionId = data["subRegionId"] !== undefined ? data["subRegionId"] : null;
            this.seen = data["seen"] !== undefined ? data["seen"] : null;
            this.seenAdmin = data["seenAdmin"] !== undefined ? data["seenAdmin"] : null;
            this.region = data["region"] ? Region.fromJS(data["region"]) : null;
            this.subRegion = data["subRegion"] ? SubRegion.fromJS(data["subRegion"]) : null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : null;
            this.location = data["location"] ? Point.fromJS(data["location"]) : null;
            this.dateStart = data["dateStart"] ? moment(data["dateStart"].toString()) : null;
            this.dateEnd = data["dateEnd"] ? moment(data["dateEnd"].toString()) : null;
            this.title = data["title"] !== undefined ? data["title"] : null;
            this.content = data["content"] !== undefined ? data["content"] : null;
            this.published = data["published"] !== undefined ? data["published"] : null;
            this.casualDating = data["casualDating"] !== undefined ? data["casualDating"] : null;
            this.advertisementCategoryId = data["advertisementCategoryId"] !== undefined ? data["advertisementCategoryId"] : null;
            this.nick = data["nick"] !== undefined ? data["nick"] : null;
            this.category = data["category"] ? AdvertisementCategory.fromJS(data["category"]) : null;
            if (Array.isArray(data["images"])) {
                this.images = [];
                for (var _i = 0, _a = data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(AdvertisementImage.fromJS(item));
                }
            }
            if (Array.isArray(data["conversations"])) {
                this.conversations = [];
                for (var _b = 0, _c = data["conversations"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.conversations.push(Conversation.fromJS(item));
                }
            }
            this.userId = data["userId"] !== undefined ? data["userId"] : null;
            this.isDemo = data["isDemo"] !== undefined ? data["isDemo"] : null;
            this.isPremium = data["isPremium"] !== undefined ? data["isPremium"] : null;
            this.isThirdParty = data["isThirdParty"] !== undefined ? data["isThirdParty"] : null;
            this.user = data["user"] ? User.fromJS(data["user"]) : null;
            this.manageId = data["manageId"] !== undefined ? data["manageId"] : null;
            this.moderated = data["moderated"] !== undefined ? data["moderated"] : null;
            this.moderatedAt = data["moderatedAt"] ? moment(data["moderatedAt"].toString()) : null;
            this.moderatedBy = data["moderatedBy"] !== undefined ? data["moderatedBy"] : null;
            this.moderateText = data["moderateText"] !== undefined ? data["moderateText"] : null;
            this.age = data["age"] !== undefined ? data["age"] : null;
            this.isExpiredMailSend = data["isExpiredMailSend"] !== undefined ? data["isExpiredMailSend"] : null;
            this.settings = data["settings"] ? AdvertisementSetting.fromJS(data["settings"]) : null;
        }
    };
    Advertisement.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Advertisement();
        result.init(data);
        return result;
    };
    Advertisement.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : null;
        data["seen"] = this.seen !== undefined ? this.seen : null;
        data["seenAdmin"] = this.seenAdmin !== undefined ? this.seenAdmin : null;
        data["region"] = this.region ? this.region.toJSON() : null;
        data["subRegion"] = this.subRegion ? this.subRegion.toJSON() : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["location"] = this.location ? this.location.toJSON() : null;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : null;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["content"] = this.content !== undefined ? this.content : null;
        data["published"] = this.published !== undefined ? this.published : null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : null;
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : null;
        data["nick"] = this.nick !== undefined ? this.nick : null;
        data["category"] = this.category ? this.category.toJSON() : null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.conversations)) {
            data["conversations"] = [];
            for (var _b = 0, _c = this.conversations; _b < _c.length; _b++) {
                var item = _c[_b];
                data["conversations"].push(item.toJSON());
            }
        }
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : null;
        data["isPremium"] = this.isPremium !== undefined ? this.isPremium : null;
        data["isThirdParty"] = this.isThirdParty !== undefined ? this.isThirdParty : null;
        data["user"] = this.user ? this.user.toJSON() : null;
        data["manageId"] = this.manageId !== undefined ? this.manageId : null;
        data["moderated"] = this.moderated !== undefined ? this.moderated : null;
        data["moderatedAt"] = this.moderatedAt ? this.moderatedAt.toISOString() : null;
        data["moderatedBy"] = this.moderatedBy !== undefined ? this.moderatedBy : null;
        data["moderateText"] = this.moderateText !== undefined ? this.moderateText : null;
        data["age"] = this.age !== undefined ? this.age : null;
        data["isExpiredMailSend"] = this.isExpiredMailSend !== undefined ? this.isExpiredMailSend : null;
        data["settings"] = this.settings ? this.settings.toJSON() : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    Advertisement.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Advertisement();
        result.init(json);
        return result;
    };
    return Advertisement;
}(BaseModel));
exports.Advertisement = Advertisement;
/** A representation of a planar, linear vector geometry. */
var Geometry = /** @class */ (function () {
    function Geometry(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Geometry.prototype.init = function (data) {
        if (data) {
            this.factory = data["factory"] ? GeometryFactory.fromJS(data["factory"]) : null;
            this.userData = data["userData"] !== undefined ? data["userData"] : null;
            this.srid = data["srid"] !== undefined ? data["srid"] : null;
            this.precisionModel = data["precisionModel"] ? PrecisionModel.fromJS(data["precisionModel"]) : null;
            this.numGeometries = data["numGeometries"] !== undefined ? data["numGeometries"] : null;
            this.isSimple = data["isSimple"] !== undefined ? data["isSimple"] : null;
            this.isValid = data["isValid"] !== undefined ? data["isValid"] : null;
            this.area = data["area"] !== undefined ? data["area"] : null;
            this.length = data["length"] !== undefined ? data["length"] : null;
            this.centroid = data["centroid"] ? Point.fromJS(data["centroid"]) : null;
            this.interiorPoint = data["interiorPoint"] ? Point.fromJS(data["interiorPoint"]) : null;
            this.pointOnSurface = data["pointOnSurface"] ? Point.fromJS(data["pointOnSurface"]) : null;
            this.envelope = data["envelope"] ? Geometry.fromJS(data["envelope"]) : null;
            this.envelopeInternal = data["envelopeInternal"] ? Envelope.fromJS(data["envelopeInternal"]) : null;
            this.isRectangle = data["isRectangle"] !== undefined ? data["isRectangle"] : null;
        }
    };
    Geometry.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Geometry' cannot be instantiated.");
    };
    Geometry.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : null;
        data["userData"] = this.userData !== undefined ? this.userData : null;
        data["srid"] = this.srid !== undefined ? this.srid : null;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : null;
        data["numGeometries"] = this.numGeometries !== undefined ? this.numGeometries : null;
        data["isSimple"] = this.isSimple !== undefined ? this.isSimple : null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : null;
        data["area"] = this.area !== undefined ? this.area : null;
        data["length"] = this.length !== undefined ? this.length : null;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : null;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : null;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : null;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : null;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : null;
        data["isRectangle"] = this.isRectangle !== undefined ? this.isRectangle : null;
        return data;
    };
    Geometry.prototype.clone = function () {
        throw new Error("The abstract class 'Geometry' cannot be instantiated.");
    };
    return Geometry;
}());
exports.Geometry = Geometry;
/** Represents a single point. A Point is topologically valid if and only if: The coordinate which defines it if any) is a valid coordinate (i.e. does not have an NaN X- or Y-ordinate */
var Point = /** @class */ (function (_super) {
    __extends(Point, _super);
    function Point(data) {
        return _super.call(this, data) || this;
    }
    Point.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.coordinateSequence = data["coordinateSequence"] ? CoordinateSequence.fromJS(data["coordinateSequence"]) : null;
            if (Array.isArray(data["coordinates"])) {
                this.coordinates = [];
                for (var _i = 0, _a = data["coordinates"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.coordinates.push(Coordinate.fromJS(item));
                }
            }
            this.numPoints = data["numPoints"] !== undefined ? data["numPoints"] : null;
            this.isEmpty = data["isEmpty"] !== undefined ? data["isEmpty"] : null;
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : null;
            this.boundaryDimension = data["boundaryDimension"] !== undefined ? data["boundaryDimension"] : null;
            this.x = data["x"] !== undefined ? data["x"] : null;
            this.y = data["y"] !== undefined ? data["y"] : null;
            this.coordinate = data["coordinate"] ? Coordinate.fromJS(data["coordinate"]) : null;
            this.geometryType = data["geometryType"] !== undefined ? data["geometryType"] : null;
            this.ogcGeometryType = data["ogcGeometryType"] !== undefined ? data["ogcGeometryType"] : null;
            this.boundary = data["boundary"] ? Geometry.fromJS(data["boundary"]) : null;
            this.z = data["z"] !== undefined ? data["z"] : null;
            this.m = data["m"] !== undefined ? data["m"] : null;
        }
    };
    Point.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Point();
        result.init(data);
        return result;
    };
    Point.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["coordinateSequence"] = this.coordinateSequence ? this.coordinateSequence.toJSON() : null;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (var _i = 0, _a = this.coordinates; _i < _a.length; _i++) {
                var item = _a[_i];
                data["coordinates"].push(item.toJSON());
            }
        }
        data["numPoints"] = this.numPoints !== undefined ? this.numPoints : null;
        data["isEmpty"] = this.isEmpty !== undefined ? this.isEmpty : null;
        data["dimension"] = this.dimension !== undefined ? this.dimension : null;
        data["boundaryDimension"] = this.boundaryDimension !== undefined ? this.boundaryDimension : null;
        data["x"] = this.x !== undefined ? this.x : null;
        data["y"] = this.y !== undefined ? this.y : null;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : null;
        data["geometryType"] = this.geometryType !== undefined ? this.geometryType : null;
        data["ogcGeometryType"] = this.ogcGeometryType !== undefined ? this.ogcGeometryType : null;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : null;
        data["z"] = this.z !== undefined ? this.z : null;
        data["m"] = this.m !== undefined ? this.m : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    Point.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Point();
        result.init(json);
        return result;
    };
    return Point;
}(Geometry));
exports.Point = Point;
/** The internal representation of a list of coordinates inside a Geometry. This allows Geometries to store their points using something other than the NTS  class. For example, a storage-efficient implementation might store coordinate sequences as an array of x's and an array of y's. Or a custom coordinate class might support extra attributes like M-values. Implementing a custom coordinate storage structure requires implementing the  and abstract classes. To use the custom CoordinateSequence, create a new  parameterized by the CoordinateSequenceFactory The  can then be used to create new s. The new Geometries will use the custom CoordinateSequence implementation. */
var CoordinateSequence = /** @class */ (function () {
    function CoordinateSequence(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CoordinateSequence.prototype.init = function (data) {
        if (data) {
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : null;
            this.measures = data["measures"] !== undefined ? data["measures"] : null;
            this.spatial = data["spatial"] !== undefined ? data["spatial"] : null;
            this.ordinates = data["ordinates"] !== undefined ? data["ordinates"] : null;
            this.hasZ = data["hasZ"] !== undefined ? data["hasZ"] : null;
            this.hasM = data["hasM"] !== undefined ? data["hasM"] : null;
            this.zOrdinateIndex = data["zOrdinateIndex"] !== undefined ? data["zOrdinateIndex"] : null;
            this.mOrdinateIndex = data["mOrdinateIndex"] !== undefined ? data["mOrdinateIndex"] : null;
            this.count = data["count"] !== undefined ? data["count"] : null;
        }
    };
    CoordinateSequence.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CoordinateSequence' cannot be instantiated.");
    };
    CoordinateSequence.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension !== undefined ? this.dimension : null;
        data["measures"] = this.measures !== undefined ? this.measures : null;
        data["spatial"] = this.spatial !== undefined ? this.spatial : null;
        data["ordinates"] = this.ordinates !== undefined ? this.ordinates : null;
        data["hasZ"] = this.hasZ !== undefined ? this.hasZ : null;
        data["hasM"] = this.hasM !== undefined ? this.hasM : null;
        data["zOrdinateIndex"] = this.zOrdinateIndex !== undefined ? this.zOrdinateIndex : null;
        data["mOrdinateIndex"] = this.mOrdinateIndex !== undefined ? this.mOrdinateIndex : null;
        data["count"] = this.count !== undefined ? this.count : null;
        return data;
    };
    CoordinateSequence.prototype.clone = function () {
        throw new Error("The abstract class 'CoordinateSequence' cannot be instantiated.");
    };
    return CoordinateSequence;
}());
exports.CoordinateSequence = CoordinateSequence;
/** Flags for Ordinate values */
var Ordinates;
(function (Ordinates) {
    Ordinates[Ordinates["None"] = 0] = "None";
    Ordinates[Ordinates["X"] = 1] = "X";
    Ordinates[Ordinates["Spatial1"] = 1] = "Spatial1";
    Ordinates[Ordinates["Y"] = 2] = "Y";
    Ordinates[Ordinates["Spatial2"] = 2] = "Spatial2";
    Ordinates[Ordinates["XY"] = 3] = "XY";
    Ordinates[Ordinates["Spatial3"] = 4] = "Spatial3";
    Ordinates[Ordinates["Z"] = 4] = "Z";
    Ordinates[Ordinates["XYZ"] = 7] = "XYZ";
    Ordinates[Ordinates["Spatial4"] = 8] = "Spatial4";
    Ordinates[Ordinates["Spatial5"] = 16] = "Spatial5";
    Ordinates[Ordinates["Spatial6"] = 32] = "Spatial6";
    Ordinates[Ordinates["Spatial7"] = 64] = "Spatial7";
    Ordinates[Ordinates["Spatial8"] = 128] = "Spatial8";
    Ordinates[Ordinates["Spatial9"] = 256] = "Spatial9";
    Ordinates[Ordinates["Spatial10"] = 512] = "Spatial10";
    Ordinates[Ordinates["Spatial11"] = 1024] = "Spatial11";
    Ordinates[Ordinates["Spatial12"] = 2048] = "Spatial12";
    Ordinates[Ordinates["Spatial13"] = 4096] = "Spatial13";
    Ordinates[Ordinates["Spatial14"] = 8192] = "Spatial14";
    Ordinates[Ordinates["Spatial15"] = 16384] = "Spatial15";
    Ordinates[Ordinates["Spatial16"] = 32768] = "Spatial16";
    Ordinates[Ordinates["AllSpatialOrdinates"] = 65535] = "AllSpatialOrdinates";
    Ordinates[Ordinates["Measure1"] = 65536] = "Measure1";
    Ordinates[Ordinates["M"] = 65536] = "M";
    Ordinates[Ordinates["XYM"] = 65539] = "XYM";
    Ordinates[Ordinates["XYZM"] = 65543] = "XYZM";
    Ordinates[Ordinates["Measure2"] = 131072] = "Measure2";
    Ordinates[Ordinates["Measure3"] = 262144] = "Measure3";
    Ordinates[Ordinates["Measure4"] = 524288] = "Measure4";
    Ordinates[Ordinates["Measure5"] = 1048576] = "Measure5";
    Ordinates[Ordinates["Measure6"] = 2097152] = "Measure6";
    Ordinates[Ordinates["Measure7"] = 4194304] = "Measure7";
    Ordinates[Ordinates["Measure8"] = 8388608] = "Measure8";
    Ordinates[Ordinates["Measure9"] = 16777216] = "Measure9";
    Ordinates[Ordinates["Measure10"] = 33554432] = "Measure10";
    Ordinates[Ordinates["Measure11"] = 67108864] = "Measure11";
    Ordinates[Ordinates["Measure12"] = 134217728] = "Measure12";
    Ordinates[Ordinates["Measure13"] = 268435456] = "Measure13";
    Ordinates[Ordinates["Measure14"] = 536870912] = "Measure14";
    Ordinates[Ordinates["Measure15"] = 1073741824] = "Measure15";
    Ordinates[Ordinates["Measure16"] = -2147483648] = "Measure16";
    Ordinates[Ordinates["AllMeasureOrdinates"] = -65536] = "AllMeasureOrdinates";
    Ordinates[Ordinates["AllOrdinates"] = -1] = "AllOrdinates";
})(Ordinates = exports.Ordinates || (exports.Ordinates = {}));
/** A lightweight class used to store coordinates on the 2-dimensional Cartesian plane. The base data object is suitable for use with coordinate sequences with dimension = 2 and measures = 0. */
var Coordinate = /** @class */ (function () {
    function Coordinate(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Coordinate.prototype.init = function (data) {
        if (data) {
            this.x = data["x"] !== undefined ? data["x"] : null;
            this.y = data["y"] !== undefined ? data["y"] : null;
            this.z = data["z"] !== undefined ? data["z"] : null;
            this.m = data["m"] !== undefined ? data["m"] : null;
            this.coordinateValue = data["coordinateValue"] ? Coordinate.fromJS(data["coordinateValue"]) : null;
        }
    };
    Coordinate.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Coordinate();
        result.init(data);
        return result;
    };
    Coordinate.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x !== undefined ? this.x : null;
        data["y"] = this.y !== undefined ? this.y : null;
        data["z"] = this.z !== undefined ? this.z : null;
        data["m"] = this.m !== undefined ? this.m : null;
        data["coordinateValue"] = this.coordinateValue ? this.coordinateValue.toJSON() : null;
        return data;
    };
    Coordinate.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Coordinate();
        result.init(json);
        return result;
    };
    return Coordinate;
}());
exports.Coordinate = Coordinate;
/** Provides constants representing the dimensions of a point, a curve and a surface. */
var Dimension;
(function (Dimension) {
    Dimension[Dimension["Point"] = 0] = "Point";
    Dimension[Dimension["Curve"] = 1] = "Curve";
    Dimension[Dimension["Surface"] = 2] = "Surface";
    Dimension[Dimension["Dontcare"] = -3] = "Dontcare";
    Dimension[Dimension["True"] = -2] = "True";
    Dimension[Dimension["False"] = -1] = "False";
})(Dimension = exports.Dimension || (exports.Dimension = {}));
/** Enumeration of OGC Geometry Types */
var OgcGeometryType;
(function (OgcGeometryType) {
    OgcGeometryType[OgcGeometryType["Point"] = 1] = "Point";
    OgcGeometryType[OgcGeometryType["LineString"] = 2] = "LineString";
    OgcGeometryType[OgcGeometryType["Polygon"] = 3] = "Polygon";
    OgcGeometryType[OgcGeometryType["MultiPoint"] = 4] = "MultiPoint";
    OgcGeometryType[OgcGeometryType["MultiLineString"] = 5] = "MultiLineString";
    OgcGeometryType[OgcGeometryType["MultiPolygon"] = 6] = "MultiPolygon";
    OgcGeometryType[OgcGeometryType["GeometryCollection"] = 7] = "GeometryCollection";
    OgcGeometryType[OgcGeometryType["CircularString"] = 8] = "CircularString";
    OgcGeometryType[OgcGeometryType["CompoundCurve"] = 9] = "CompoundCurve";
    OgcGeometryType[OgcGeometryType["CurvePolygon"] = 10] = "CurvePolygon";
    OgcGeometryType[OgcGeometryType["MultiCurve"] = 11] = "MultiCurve";
    OgcGeometryType[OgcGeometryType["MultiSurface"] = 12] = "MultiSurface";
    OgcGeometryType[OgcGeometryType["Curve"] = 13] = "Curve";
    OgcGeometryType[OgcGeometryType["Surface"] = 14] = "Surface";
    OgcGeometryType[OgcGeometryType["PolyhedralSurface"] = 15] = "PolyhedralSurface";
    OgcGeometryType[OgcGeometryType["TIN"] = 16] = "TIN";
})(OgcGeometryType = exports.OgcGeometryType || (exports.OgcGeometryType = {}));
/** Supplies a set of utility methods for building Geometry objects from lists of Coordinates. */
var GeometryFactory = /** @class */ (function () {
    function GeometryFactory(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GeometryFactory.prototype.init = function (data) {
        if (data) {
            this.precisionModel = data["precisionModel"] ? PrecisionModel.fromJS(data["precisionModel"]) : null;
            this.coordinateSequenceFactory = data["coordinateSequenceFactory"] ? CoordinateSequenceFactory.fromJS(data["coordinateSequenceFactory"]) : null;
            this.srid = data["srid"] !== undefined ? data["srid"] : null;
        }
    };
    GeometryFactory.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GeometryFactory();
        result.init(data);
        return result;
    };
    GeometryFactory.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : null;
        data["coordinateSequenceFactory"] = this.coordinateSequenceFactory ? this.coordinateSequenceFactory.toJSON() : null;
        data["srid"] = this.srid !== undefined ? this.srid : null;
        return data;
    };
    GeometryFactory.prototype.clone = function () {
        var json = this.toJSON();
        var result = new GeometryFactory();
        result.init(json);
        return result;
    };
    return GeometryFactory;
}());
exports.GeometryFactory = GeometryFactory;
/** Specifies the precision model of the Coordinates in a Geometry. In other words, specifies the grid of allowable points for all Geometrys. */
var PrecisionModel = /** @class */ (function () {
    function PrecisionModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PrecisionModel.prototype.init = function (data) {
        if (data) {
            this.isFloating = data["isFloating"] !== undefined ? data["isFloating"] : null;
            this.maximumSignificantDigits = data["maximumSignificantDigits"] !== undefined ? data["maximumSignificantDigits"] : null;
            this.scale = data["scale"] !== undefined ? data["scale"] : null;
            this.precisionModelType = data["precisionModelType"] !== undefined ? data["precisionModelType"] : null;
        }
    };
    PrecisionModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PrecisionModel();
        result.init(data);
        return result;
    };
    PrecisionModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isFloating"] = this.isFloating !== undefined ? this.isFloating : null;
        data["maximumSignificantDigits"] = this.maximumSignificantDigits !== undefined ? this.maximumSignificantDigits : null;
        data["scale"] = this.scale !== undefined ? this.scale : null;
        data["precisionModelType"] = this.precisionModelType !== undefined ? this.precisionModelType : null;
        return data;
    };
    PrecisionModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PrecisionModel();
        result.init(json);
        return result;
    };
    return PrecisionModel;
}());
exports.PrecisionModel = PrecisionModel;
var PrecisionModels;
(function (PrecisionModels) {
    PrecisionModels[PrecisionModels["Floating"] = 0] = "Floating";
    PrecisionModels[PrecisionModels["FloatingSingle"] = 1] = "FloatingSingle";
    PrecisionModels[PrecisionModels["Fixed"] = 2] = "Fixed";
})(PrecisionModels = exports.PrecisionModels || (exports.PrecisionModels = {}));
/** An object that knows how to build a particular implementation of CoordinateSequence from an array of Coordinates. */
var CoordinateSequenceFactory = /** @class */ (function () {
    function CoordinateSequenceFactory(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CoordinateSequenceFactory.prototype.init = function (data) {
        if (data) {
            this.ordinates = data["ordinates"] !== undefined ? data["ordinates"] : null;
        }
    };
    CoordinateSequenceFactory.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CoordinateSequenceFactory' cannot be instantiated.");
    };
    CoordinateSequenceFactory.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["ordinates"] = this.ordinates !== undefined ? this.ordinates : null;
        return data;
    };
    CoordinateSequenceFactory.prototype.clone = function () {
        throw new Error("The abstract class 'CoordinateSequenceFactory' cannot be instantiated.");
    };
    return CoordinateSequenceFactory;
}());
exports.CoordinateSequenceFactory = CoordinateSequenceFactory;
/** Defines a rectangular region of the 2D coordinate plane. */
var Envelope = /** @class */ (function () {
    function Envelope(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Envelope.prototype.init = function (data) {
        if (data) {
            this.isNull = data["isNull"] !== undefined ? data["isNull"] : null;
            this.width = data["width"] !== undefined ? data["width"] : null;
            this.height = data["height"] !== undefined ? data["height"] : null;
            this.minX = data["minX"] !== undefined ? data["minX"] : null;
            this.maxX = data["maxX"] !== undefined ? data["maxX"] : null;
            this.minY = data["minY"] !== undefined ? data["minY"] : null;
            this.maxY = data["maxY"] !== undefined ? data["maxY"] : null;
            this.area = data["area"] !== undefined ? data["area"] : null;
            this.minExtent = data["minExtent"] !== undefined ? data["minExtent"] : null;
            this.maxExtent = data["maxExtent"] !== undefined ? data["maxExtent"] : null;
            this.centre = data["centre"] ? Coordinate.fromJS(data["centre"]) : null;
        }
    };
    Envelope.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Envelope();
        result.init(data);
        return result;
    };
    Envelope.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isNull"] = this.isNull !== undefined ? this.isNull : null;
        data["width"] = this.width !== undefined ? this.width : null;
        data["height"] = this.height !== undefined ? this.height : null;
        data["minX"] = this.minX !== undefined ? this.minX : null;
        data["maxX"] = this.maxX !== undefined ? this.maxX : null;
        data["minY"] = this.minY !== undefined ? this.minY : null;
        data["maxY"] = this.maxY !== undefined ? this.maxY : null;
        data["area"] = this.area !== undefined ? this.area : null;
        data["minExtent"] = this.minExtent !== undefined ? this.minExtent : null;
        data["maxExtent"] = this.maxExtent !== undefined ? this.maxExtent : null;
        data["centre"] = this.centre ? this.centre.toJSON() : null;
        return data;
    };
    Envelope.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Envelope();
        result.init(json);
        return result;
    };
    return Envelope;
}());
exports.Envelope = Envelope;
var AdvertisementCategory = /** @class */ (function (_super) {
    __extends(AdvertisementCategory, _super);
    function AdvertisementCategory(data) {
        return _super.call(this, data) || this;
    }
    AdvertisementCategory.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.advertisementCategoryId = data["advertisementCategoryId"] !== undefined ? data["advertisementCategoryId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : null;
            this.casualDating = data["casualDating"] !== undefined ? data["casualDating"] : null;
        }
    };
    AdvertisementCategory.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdvertisementCategory();
        result.init(data);
        return result;
    };
    AdvertisementCategory.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdvertisementCategory.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdvertisementCategory();
        result.init(json);
        return result;
    };
    return AdvertisementCategory;
}(BaseModel));
exports.AdvertisementCategory = AdvertisementCategory;
var AdvertisementImage = /** @class */ (function (_super) {
    __extends(AdvertisementImage, _super);
    function AdvertisementImage(data) {
        return _super.call(this, data) || this;
    }
    AdvertisementImage.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.advertisementImageId = data["advertisementImageId"] !== undefined ? data["advertisementImageId"] : null;
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : null;
            this.advertisement = data["advertisement"] ? Advertisement.fromJS(data["advertisement"]) : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null;
            this.orgFileName = data["orgFileName"] !== undefined ? data["orgFileName"] : null;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : null;
            this.isMain = data["isMain"] !== undefined ? data["isMain"] : null;
        }
    };
    AdvertisementImage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdvertisementImage();
        result.init(data);
        return result;
    };
    AdvertisementImage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementImageId"] = this.advertisementImageId !== undefined ? this.advertisementImageId : null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["advertisement"] = this.advertisement ? this.advertisement.toJSON() : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["orgFileName"] = this.orgFileName !== undefined ? this.orgFileName : null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : null;
        data["isMain"] = this.isMain !== undefined ? this.isMain : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdvertisementImage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdvertisementImage();
        result.init(json);
        return result;
    };
    return AdvertisementImage;
}(BaseModel));
exports.AdvertisementImage = AdvertisementImage;
var Conversation = /** @class */ (function () {
    function Conversation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Conversation.prototype.init = function (data) {
        if (data) {
            this.conversationId = data["conversationId"] !== undefined ? data["conversationId"] : null;
            this.senderEmail = data["senderEmail"] !== undefined ? data["senderEmail"] : null;
            this.senderNick = data["senderNick"] !== undefined ? data["senderNick"] : null;
            this.receiverNick = data["receiverNick"] !== undefined ? data["receiverNick"] : null;
            this.receiverEmail = data["receiverEmail"] !== undefined ? data["receiverEmail"] : null;
            this.conversationKey = data["conversationKey"] !== undefined ? data["conversationKey"] : null;
            this.creationDate = data["creationDate"] ? moment(data["creationDate"].toString()) : null;
            this.ownerUserId = data["ownerUserId"] !== undefined ? data["ownerUserId"] : null;
            this.ownerUser = data["ownerUser"] ? User.fromJS(data["ownerUser"]) : null;
            this.receiverUserId = data["receiverUserId"] !== undefined ? data["receiverUserId"] : null;
            this.receiverUser = data["receiverUser"] ? User.fromJS(data["receiverUser"]) : null;
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : null;
            this.advertisement = data["advertisement"] ? Advertisement.fromJS(data["advertisement"]) : null;
            this.additionalData = data["additionalData"] !== undefined ? data["additionalData"] : null;
            this.isDeletedOwner = data["isDeletedOwner"] !== undefined ? data["isDeletedOwner"] : null;
            this.isDeletedReceiver = data["isDeletedReceiver"] !== undefined ? data["isDeletedReceiver"] : null;
            this.senderNewMessages = data["senderNewMessages"] !== undefined ? data["senderNewMessages"] : null;
            this.receiverNewMessages = data["receiverNewMessages"] !== undefined ? data["receiverNewMessages"] : null;
            this.isForDemoAd = data["isForDemoAd"] !== undefined ? data["isForDemoAd"] : null;
            this.additionalInformation = data["additionalInformation"] ? ConversationAdditionalInformations.fromJS(data["additionalInformation"]) : null;
            if (Array.isArray(data["messages"])) {
                this.messages = [];
                for (var _i = 0, _a = data["messages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.messages.push(ConversationMessage.fromJS(item));
                }
            }
            this.lastMessageDate = data["lastMessageDate"] ? moment(data["lastMessageDate"].toString()) : null;
        }
    };
    Conversation.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Conversation();
        result.init(data);
        return result;
    };
    Conversation.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : null;
        data["senderEmail"] = this.senderEmail !== undefined ? this.senderEmail : null;
        data["senderNick"] = this.senderNick !== undefined ? this.senderNick : null;
        data["receiverNick"] = this.receiverNick !== undefined ? this.receiverNick : null;
        data["receiverEmail"] = this.receiverEmail !== undefined ? this.receiverEmail : null;
        data["conversationKey"] = this.conversationKey !== undefined ? this.conversationKey : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["ownerUserId"] = this.ownerUserId !== undefined ? this.ownerUserId : null;
        data["ownerUser"] = this.ownerUser ? this.ownerUser.toJSON() : null;
        data["receiverUserId"] = this.receiverUserId !== undefined ? this.receiverUserId : null;
        data["receiverUser"] = this.receiverUser ? this.receiverUser.toJSON() : null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["advertisement"] = this.advertisement ? this.advertisement.toJSON() : null;
        data["additionalData"] = this.additionalData !== undefined ? this.additionalData : null;
        data["isDeletedOwner"] = this.isDeletedOwner !== undefined ? this.isDeletedOwner : null;
        data["isDeletedReceiver"] = this.isDeletedReceiver !== undefined ? this.isDeletedReceiver : null;
        data["senderNewMessages"] = this.senderNewMessages !== undefined ? this.senderNewMessages : null;
        data["receiverNewMessages"] = this.receiverNewMessages !== undefined ? this.receiverNewMessages : null;
        data["isForDemoAd"] = this.isForDemoAd !== undefined ? this.isForDemoAd : null;
        data["additionalInformation"] = this.additionalInformation ? this.additionalInformation.toJSON() : null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (var _i = 0, _a = this.messages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["messages"].push(item.toJSON());
            }
        }
        data["lastMessageDate"] = this.lastMessageDate ? this.lastMessageDate.toISOString() : null;
        return data;
    };
    Conversation.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Conversation();
        result.init(json);
        return result;
    };
    return Conversation;
}());
exports.Conversation = Conversation;
var User = /** @class */ (function () {
    function User(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    User.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"] !== undefined ? data["userId"] : null;
            this.createdAt = data["createdAt"] ? moment(data["createdAt"].toString()) : null;
            this.updatedAt = data["updatedAt"] ? moment(data["updatedAt"].toString()) : null;
            this.nick = data["nick"] !== undefined ? data["nick"] : null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : null;
            this.email = data["email"] !== undefined ? data["email"] : null;
            this.phone = data["phone"] !== undefined ? data["phone"] : null;
            this.password = data["password"] !== undefined ? data["password"] : null;
            this.passwordSalt = data["passwordSalt"] !== undefined ? data["passwordSalt"] : null;
            this.isDemo = data["isDemo"] !== undefined ? data["isDemo"] : null;
            this.isInternal = data["isInternal"] !== undefined ? data["isInternal"] : null;
            this.isAdmin = data["isAdmin"] !== undefined ? data["isAdmin"] : null;
            this.isEmailVerified = data["isEmailVerified"] !== undefined ? data["isEmailVerified"] : null;
            this.isPremium = data["isPremium"] !== undefined ? data["isPremium"] : null;
            this.isPhoneVerified = data["isPhoneVerified"] !== undefined ? data["isPhoneVerified"] : null;
            this.isDisabled = data["isDisabled"] !== undefined ? data["isDisabled"] : null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : null;
            this.city = data["city"] !== undefined ? data["city"] : null;
            this.state = data["state"] !== undefined ? data["state"] : null;
            this.location = data["location"] ? Point.fromJS(data["location"]) : null;
            this.premiumAdTokens = data["premiumAdTokens"] !== undefined ? data["premiumAdTokens"] : null;
            this.writeAdTokens = data["writeAdTokens"] !== undefined ? data["writeAdTokens"] : null;
            this.thirdPartyAdTokens = data["thirdPartyAdTokens"] !== undefined ? data["thirdPartyAdTokens"] : null;
            this.subscribtionExpiration = data["subscribtionExpiration"] ? moment(data["subscribtionExpiration"].toString()) : null;
        }
    };
    User.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new User();
        result.init(data);
        return result;
    };
    User.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : null;
        data["nick"] = this.nick !== undefined ? this.nick : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["email"] = this.email !== undefined ? this.email : null;
        data["phone"] = this.phone !== undefined ? this.phone : null;
        data["password"] = this.password !== undefined ? this.password : null;
        data["passwordSalt"] = this.passwordSalt !== undefined ? this.passwordSalt : null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : null;
        data["isInternal"] = this.isInternal !== undefined ? this.isInternal : null;
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : null;
        data["isEmailVerified"] = this.isEmailVerified !== undefined ? this.isEmailVerified : null;
        data["isPremium"] = this.isPremium !== undefined ? this.isPremium : null;
        data["isPhoneVerified"] = this.isPhoneVerified !== undefined ? this.isPhoneVerified : null;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["state"] = this.state !== undefined ? this.state : null;
        data["location"] = this.location ? this.location.toJSON() : null;
        data["premiumAdTokens"] = this.premiumAdTokens !== undefined ? this.premiumAdTokens : null;
        data["writeAdTokens"] = this.writeAdTokens !== undefined ? this.writeAdTokens : null;
        data["thirdPartyAdTokens"] = this.thirdPartyAdTokens !== undefined ? this.thirdPartyAdTokens : null;
        data["subscribtionExpiration"] = this.subscribtionExpiration ? this.subscribtionExpiration.toISOString() : null;
        return data;
    };
    User.prototype.clone = function () {
        var json = this.toJSON();
        var result = new User();
        result.init(json);
        return result;
    };
    return User;
}());
exports.User = User;
var ConversationMessage = /** @class */ (function () {
    function ConversationMessage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConversationMessage.prototype.init = function (data) {
        if (data) {
            this.conversationMessageId = data["conversationMessageId"] !== undefined ? data["conversationMessageId"] : null;
            this.conversation = data["conversation"] ? Conversation.fromJS(data["conversation"]) : null;
            this.content = data["content"] !== undefined ? data["content"] : null;
            this.creationDate = data["creationDate"] ? moment(data["creationDate"].toString()) : null;
            this.sender = data["sender"] ? User.fromJS(data["sender"]) : null;
            this.senderId = data["senderId"] !== undefined ? data["senderId"] : null;
            this.title = data["title"] !== undefined ? data["title"] : null;
            if (Array.isArray(data["images"])) {
                this.images = [];
                for (var _i = 0, _a = data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(ConversationImage.fromJS(item));
                }
            }
            this.isRead = data["isRead"] !== undefined ? data["isRead"] : null;
        }
    };
    ConversationMessage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConversationMessage();
        result.init(data);
        return result;
    };
    ConversationMessage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationMessageId"] = this.conversationMessageId !== undefined ? this.conversationMessageId : null;
        data["conversation"] = this.conversation ? this.conversation.toJSON() : null;
        data["content"] = this.content !== undefined ? this.content : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["sender"] = this.sender ? this.sender.toJSON() : null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : null;
        data["title"] = this.title !== undefined ? this.title : null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        data["isRead"] = this.isRead !== undefined ? this.isRead : null;
        return data;
    };
    ConversationMessage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ConversationMessage();
        result.init(json);
        return result;
    };
    return ConversationMessage;
}());
exports.ConversationMessage = ConversationMessage;
var ConversationImage = /** @class */ (function () {
    function ConversationImage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConversationImage.prototype.init = function (data) {
        if (data) {
            this.conversationImageId = data["conversationImageId"] !== undefined ? data["conversationImageId"] : null;
            this.conversationMessage = data["conversationMessage"] ? ConversationMessage.fromJS(data["conversationMessage"]) : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null;
        }
    };
    ConversationImage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConversationImage();
        result.init(data);
        return result;
    };
    ConversationImage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationImageId"] = this.conversationImageId !== undefined ? this.conversationImageId : null;
        data["conversationMessage"] = this.conversationMessage ? this.conversationMessage.toJSON() : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        return data;
    };
    ConversationImage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ConversationImage();
        result.init(json);
        return result;
    };
    return ConversationImage;
}());
exports.ConversationImage = ConversationImage;
var AdvertisementSetting = /** @class */ (function () {
    function AdvertisementSetting(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdvertisementSetting.prototype.init = function (data) {
        if (data) {
            this.advertisementSettingId = data["advertisementSettingId"] !== undefined ? data["advertisementSettingId"] : null;
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : null;
            this.showAs = data["showAs"] !== undefined ? data["showAs"] : null;
            this.advertisement = data["advertisement"] ? Advertisement.fromJS(data["advertisement"]) : null;
        }
    };
    AdvertisementSetting.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdvertisementSetting();
        result.init(data);
        return result;
    };
    AdvertisementSetting.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementSettingId"] = this.advertisementSettingId !== undefined ? this.advertisementSettingId : null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["showAs"] = this.showAs !== undefined ? this.showAs : null;
        data["advertisement"] = this.advertisement ? this.advertisement.toJSON() : null;
        return data;
    };
    AdvertisementSetting.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdvertisementSetting();
        result.init(json);
        return result;
    };
    return AdvertisementSetting;
}());
exports.AdvertisementSetting = AdvertisementSetting;
var VerifyPhoneResponseModel = /** @class */ (function (_super) {
    __extends(VerifyPhoneResponseModel, _super);
    function VerifyPhoneResponseModel(data) {
        return _super.call(this, data) || this;
    }
    VerifyPhoneResponseModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
    };
    VerifyPhoneResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VerifyPhoneResponseModel();
        result.init(data);
        return result;
    };
    VerifyPhoneResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    VerifyPhoneResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new VerifyPhoneResponseModel();
        result.init(json);
        return result;
    };
    return VerifyPhoneResponseModel;
}(ResponseBaseModel));
exports.VerifyPhoneResponseModel = VerifyPhoneResponseModel;
var VerifyPhoneModel = /** @class */ (function () {
    function VerifyPhoneModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VerifyPhoneModel.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"] !== undefined ? data["userId"] : null;
        }
    };
    VerifyPhoneModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VerifyPhoneModel();
        result.init(data);
        return result;
    };
    VerifyPhoneModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        return data;
    };
    VerifyPhoneModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new VerifyPhoneModel();
        result.init(json);
        return result;
    };
    return VerifyPhoneModel;
}());
exports.VerifyPhoneModel = VerifyPhoneModel;
var ZipRequest = /** @class */ (function () {
    function ZipRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ZipRequest.prototype.init = function (data) {
        if (data) {
            this.zip = data["zip"] !== undefined ? data["zip"] : null;
        }
    };
    ZipRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ZipRequest();
        result.init(data);
        return result;
    };
    ZipRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["zip"] = this.zip !== undefined ? this.zip : null;
        return data;
    };
    ZipRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ZipRequest();
        result.init(json);
        return result;
    };
    return ZipRequest;
}());
exports.ZipRequest = ZipRequest;
var WeatherForecast = /** @class */ (function () {
    function WeatherForecast(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WeatherForecast.prototype.init = function (data) {
        if (data) {
            this.dateFormatted = data["dateFormatted"] !== undefined ? data["dateFormatted"] : null;
            this.temperatureC = data["temperatureC"] !== undefined ? data["temperatureC"] : null;
            this.summary = data["summary"] !== undefined ? data["summary"] : null;
            this.temperatureF = data["temperatureF"] !== undefined ? data["temperatureF"] : null;
        }
    };
    WeatherForecast.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WeatherForecast();
        result.init(data);
        return result;
    };
    WeatherForecast.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dateFormatted"] = this.dateFormatted !== undefined ? this.dateFormatted : null;
        data["temperatureC"] = this.temperatureC !== undefined ? this.temperatureC : null;
        data["summary"] = this.summary !== undefined ? this.summary : null;
        data["temperatureF"] = this.temperatureF !== undefined ? this.temperatureF : null;
        return data;
    };
    WeatherForecast.prototype.clone = function () {
        var json = this.toJSON();
        var result = new WeatherForecast();
        result.init(json);
        return result;
    };
    return WeatherForecast;
}());
exports.WeatherForecast = WeatherForecast;
var GetSeoMetaTextsResponseModel = /** @class */ (function (_super) {
    __extends(GetSeoMetaTextsResponseModel, _super);
    function GetSeoMetaTextsResponseModel(data) {
        return _super.call(this, data) || this;
    }
    GetSeoMetaTextsResponseModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.metaTitle = data["metaTitle"] !== undefined ? data["metaTitle"] : null;
            this.metaDescription = data["metaDescription"] !== undefined ? data["metaDescription"] : null;
        }
    };
    GetSeoMetaTextsResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetSeoMetaTextsResponseModel();
        result.init(data);
        return result;
    };
    GetSeoMetaTextsResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["metaTitle"] = this.metaTitle !== undefined ? this.metaTitle : null;
        data["metaDescription"] = this.metaDescription !== undefined ? this.metaDescription : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    GetSeoMetaTextsResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new GetSeoMetaTextsResponseModel();
        result.init(json);
        return result;
    };
    return GetSeoMetaTextsResponseModel;
}(ResponseBaseModel));
exports.GetSeoMetaTextsResponseModel = GetSeoMetaTextsResponseModel;
var ServiceResponseBase = /** @class */ (function () {
    function ServiceResponseBase(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ServiceResponseBase.prototype.init = function (data) {
        if (data) {
            this.isError = data["isError"] !== undefined ? data["isError"] : null;
            this.message = data["message"] !== undefined ? data["message"] : null;
        }
    };
    ServiceResponseBase.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServiceResponseBase' cannot be instantiated.");
    };
    ServiceResponseBase.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isError"] = this.isError !== undefined ? this.isError : null;
        data["message"] = this.message !== undefined ? this.message : null;
        return data;
    };
    ServiceResponseBase.prototype.clone = function () {
        throw new Error("The abstract class 'ServiceResponseBase' cannot be instantiated.");
    };
    return ServiceResponseBase;
}());
exports.ServiceResponseBase = ServiceResponseBase;
var CreateServiceResponse = /** @class */ (function (_super) {
    __extends(CreateServiceResponse, _super);
    function CreateServiceResponse(data) {
        return _super.call(this, data) || this;
    }
    CreateServiceResponse.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.isCreated = data["isCreated"] !== undefined ? data["isCreated"] : null;
            this.token = data["token"] !== undefined ? data["token"] : null;
        }
    };
    CreateServiceResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateServiceResponse();
        result.init(data);
        return result;
    };
    CreateServiceResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : null;
        data["token"] = this.token !== undefined ? this.token : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    CreateServiceResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CreateServiceResponse();
        result.init(json);
        return result;
    };
    return CreateServiceResponse;
}(ServiceResponseBase));
exports.CreateServiceResponse = CreateServiceResponse;
var Subscribe = /** @class */ (function () {
    function Subscribe(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Subscribe.prototype.init = function (data) {
        if (data) {
            this.cardNumber = data["cardNumber"] !== undefined ? data["cardNumber"] : null;
            this.expirationDate = data["expirationDate"] !== undefined ? data["expirationDate"] : null;
            this.zip = data["zip"] !== undefined ? data["zip"] : null;
            this.securityCode = data["securityCode"] !== undefined ? data["securityCode"] : null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : null;
            this.period = data["period"] !== undefined ? data["period"] : null;
        }
    };
    Subscribe.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Subscribe();
        result.init(data);
        return result;
    };
    Subscribe.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : null;
        data["zip"] = this.zip !== undefined ? this.zip : null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["period"] = this.period !== undefined ? this.period : null;
        return data;
    };
    Subscribe.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Subscribe();
        result.init(json);
        return result;
    };
    return Subscribe;
}());
exports.Subscribe = Subscribe;
var Period;
(function (Period) {
    Period[Period["Year"] = 1] = "Year";
    Period[Period["Month"] = 2] = "Month";
    Period[Period["SinglePremiumAd"] = 3] = "SinglePremiumAd";
})(Period = exports.Period || (exports.Period = {}));
var SubscribtionData = /** @class */ (function () {
    function SubscribtionData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubscribtionData.prototype.init = function (data) {
        if (data) {
            this.subscribtionId = data["subscribtionId"] !== undefined ? data["subscribtionId"] : null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : null;
            this.creditCard = data["creditCard"] !== undefined ? data["creditCard"] : null;
            this.zip = data["zip"] !== undefined ? data["zip"] : null;
            this.type = data["type"] !== undefined ? data["type"] : null;
            this.price = data["price"] !== undefined ? data["price"] : null;
            this.nextBillingDate = data["nextBillingDate"] ? moment(data["nextBillingDate"].toString()) : null;
            this.status = data["status"] !== undefined ? data["status"] : null;
        }
    };
    SubscribtionData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubscribtionData();
        result.init(data);
        return result;
    };
    SubscribtionData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["subscribtionId"] = this.subscribtionId !== undefined ? this.subscribtionId : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["creditCard"] = this.creditCard !== undefined ? this.creditCard : null;
        data["zip"] = this.zip !== undefined ? this.zip : null;
        data["type"] = this.type !== undefined ? this.type : null;
        data["price"] = this.price !== undefined ? this.price : null;
        data["nextBillingDate"] = this.nextBillingDate ? this.nextBillingDate.toISOString() : null;
        data["status"] = this.status !== undefined ? this.status : null;
        return data;
    };
    SubscribtionData.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SubscribtionData();
        result.init(json);
        return result;
    };
    return SubscribtionData;
}());
exports.SubscribtionData = SubscribtionData;
var Status;
(function (Status) {
    Status[Status["Active"] = 0] = "Active";
    Status[Status["InActive"] = 1] = "InActive";
    Status[Status["Canceled"] = 2] = "Canceled";
    Status[Status["Expired"] = 3] = "Expired";
    Status[Status["Suspended"] = 4] = "Suspended";
    Status[Status["Terminated"] = 5] = "Terminated";
})(Status = exports.Status || (exports.Status = {}));
var AddPremiumAdTokenResponse = /** @class */ (function (_super) {
    __extends(AddPremiumAdTokenResponse, _super);
    function AddPremiumAdTokenResponse(data) {
        return _super.call(this, data) || this;
    }
    AddPremiumAdTokenResponse.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.isCreated = data["isCreated"] !== undefined ? data["isCreated"] : null;
        }
    };
    AddPremiumAdTokenResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddPremiumAdTokenResponse();
        result.init(data);
        return result;
    };
    AddPremiumAdTokenResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AddPremiumAdTokenResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AddPremiumAdTokenResponse();
        result.init(json);
        return result;
    };
    return AddPremiumAdTokenResponse;
}(ServiceResponseBase));
exports.AddPremiumAdTokenResponse = AddPremiumAdTokenResponse;
var AddPremiumAdToken = /** @class */ (function () {
    function AddPremiumAdToken(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddPremiumAdToken.prototype.init = function (data) {
        if (data) {
            this.cardNumber = data["cardNumber"] !== undefined ? data["cardNumber"] : null;
            this.expirationDate = data["expirationDate"] !== undefined ? data["expirationDate"] : null;
            this.zip = data["zip"] !== undefined ? data["zip"] : null;
            this.securityCode = data["securityCode"] !== undefined ? data["securityCode"] : null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : null;
        }
    };
    AddPremiumAdToken.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddPremiumAdToken();
        result.init(data);
        return result;
    };
    AddPremiumAdToken.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : null;
        data["zip"] = this.zip !== undefined ? this.zip : null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        return data;
    };
    AddPremiumAdToken.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AddPremiumAdToken();
        result.init(json);
        return result;
    };
    return AddPremiumAdToken;
}());
exports.AddPremiumAdToken = AddPremiumAdToken;
var AddWriteAdTokenResponse = /** @class */ (function (_super) {
    __extends(AddWriteAdTokenResponse, _super);
    function AddWriteAdTokenResponse(data) {
        return _super.call(this, data) || this;
    }
    AddWriteAdTokenResponse.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.isCreated = data["isCreated"] !== undefined ? data["isCreated"] : null;
        }
    };
    AddWriteAdTokenResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddWriteAdTokenResponse();
        result.init(data);
        return result;
    };
    AddWriteAdTokenResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AddWriteAdTokenResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AddWriteAdTokenResponse();
        result.init(json);
        return result;
    };
    return AddWriteAdTokenResponse;
}(ServiceResponseBase));
exports.AddWriteAdTokenResponse = AddWriteAdTokenResponse;
var AddWriteAdToken = /** @class */ (function () {
    function AddWriteAdToken(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddWriteAdToken.prototype.init = function (data) {
        if (data) {
            this.cardNumber = data["cardNumber"] !== undefined ? data["cardNumber"] : null;
            this.expirationDate = data["expirationDate"] !== undefined ? data["expirationDate"] : null;
            this.zip = data["zip"] !== undefined ? data["zip"] : null;
            this.securityCode = data["securityCode"] !== undefined ? data["securityCode"] : null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : null;
        }
    };
    AddWriteAdToken.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddWriteAdToken();
        result.init(data);
        return result;
    };
    AddWriteAdToken.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : null;
        data["zip"] = this.zip !== undefined ? this.zip : null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        return data;
    };
    AddWriteAdToken.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AddWriteAdToken();
        result.init(json);
        return result;
    };
    return AddWriteAdToken;
}());
exports.AddWriteAdToken = AddWriteAdToken;
var AddThirdPartyAdTokenResponse = /** @class */ (function (_super) {
    __extends(AddThirdPartyAdTokenResponse, _super);
    function AddThirdPartyAdTokenResponse(data) {
        return _super.call(this, data) || this;
    }
    AddThirdPartyAdTokenResponse.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.isCreated = data["isCreated"] !== undefined ? data["isCreated"] : null;
        }
    };
    AddThirdPartyAdTokenResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddThirdPartyAdTokenResponse();
        result.init(data);
        return result;
    };
    AddThirdPartyAdTokenResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AddThirdPartyAdTokenResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AddThirdPartyAdTokenResponse();
        result.init(json);
        return result;
    };
    return AddThirdPartyAdTokenResponse;
}(ServiceResponseBase));
exports.AddThirdPartyAdTokenResponse = AddThirdPartyAdTokenResponse;
var AddThirdPartyAdToken = /** @class */ (function () {
    function AddThirdPartyAdToken(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddThirdPartyAdToken.prototype.init = function (data) {
        if (data) {
            this.cardNumber = data["cardNumber"] !== undefined ? data["cardNumber"] : null;
            this.expirationDate = data["expirationDate"] !== undefined ? data["expirationDate"] : null;
            this.zip = data["zip"] !== undefined ? data["zip"] : null;
            this.securityCode = data["securityCode"] !== undefined ? data["securityCode"] : null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : null;
        }
    };
    AddThirdPartyAdToken.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddThirdPartyAdToken();
        result.init(data);
        return result;
    };
    AddThirdPartyAdToken.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : null;
        data["zip"] = this.zip !== undefined ? this.zip : null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        return data;
    };
    AddThirdPartyAdToken.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AddThirdPartyAdToken();
        result.init(json);
        return result;
    };
    return AddThirdPartyAdToken;
}());
exports.AddThirdPartyAdToken = AddThirdPartyAdToken;
var AddBanerResponse = /** @class */ (function (_super) {
    __extends(AddBanerResponse, _super);
    function AddBanerResponse(data) {
        return _super.call(this, data) || this;
    }
    AddBanerResponse.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.isCreated = data["isCreated"] !== undefined ? data["isCreated"] : null;
        }
    };
    AddBanerResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddBanerResponse();
        result.init(data);
        return result;
    };
    AddBanerResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AddBanerResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AddBanerResponse();
        result.init(json);
        return result;
    };
    return AddBanerResponse;
}(ServiceResponseBase));
exports.AddBanerResponse = AddBanerResponse;
var AddBaner = /** @class */ (function () {
    function AddBaner(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddBaner.prototype.init = function (data) {
        if (data) {
            this.cardNumber = data["cardNumber"] !== undefined ? data["cardNumber"] : null;
            this.expirationDate = data["expirationDate"] !== undefined ? data["expirationDate"] : null;
            this.zip = data["zip"] !== undefined ? data["zip"] : null;
            this.securityCode = data["securityCode"] !== undefined ? data["securityCode"] : null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : null;
            this.banerUrl = data["banerUrl"] !== undefined ? data["banerUrl"] : null;
            this.desktopImageHorizontal = data["desktopImageHorizontal"] !== undefined ? data["desktopImageHorizontal"] : null;
            this.desktopImageVertical = data["desktopImageVertical"] !== undefined ? data["desktopImageVertical"] : null;
            this.mobileImage = data["mobileImage"] !== undefined ? data["mobileImage"] : null;
            this.isMobile = data["isMobile"] !== undefined ? data["isMobile"] : null;
        }
    };
    AddBaner.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddBaner();
        result.init(data);
        return result;
    };
    AddBaner.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : null;
        data["zip"] = this.zip !== undefined ? this.zip : null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["banerUrl"] = this.banerUrl !== undefined ? this.banerUrl : null;
        data["desktopImageHorizontal"] = this.desktopImageHorizontal !== undefined ? this.desktopImageHorizontal : null;
        data["desktopImageVertical"] = this.desktopImageVertical !== undefined ? this.desktopImageVertical : null;
        data["mobileImage"] = this.mobileImage !== undefined ? this.mobileImage : null;
        data["isMobile"] = this.isMobile !== undefined ? this.isMobile : null;
        return data;
    };
    AddBaner.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AddBaner();
        result.init(json);
        return result;
    };
    return AddBaner;
}());
exports.AddBaner = AddBaner;
var RegistrationResponseModel = /** @class */ (function (_super) {
    __extends(RegistrationResponseModel, _super);
    function RegistrationResponseModel(data) {
        return _super.call(this, data) || this;
    }
    RegistrationResponseModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
    };
    RegistrationResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegistrationResponseModel();
        result.init(data);
        return result;
    };
    RegistrationResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    RegistrationResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new RegistrationResponseModel();
        result.init(json);
        return result;
    };
    return RegistrationResponseModel;
}(ResponseBaseModel));
exports.RegistrationResponseModel = RegistrationResponseModel;
var RegistrationModel = /** @class */ (function () {
    function RegistrationModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegistrationModel.prototype.init = function (data) {
        if (data) {
            this.email = data["email"] !== undefined ? data["email"] : null;
            this.password = data["password"] !== undefined ? data["password"] : null;
            this.passwordConfirmation = data["passwordConfirmation"] !== undefined ? data["passwordConfirmation"] : null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : null;
            this.city = data["city"] !== undefined ? data["city"] : null;
            this.state = data["state"] !== undefined ? data["state"] : null;
            this.phone = data["phone"] !== undefined ? data["phone"] : null;
        }
    };
    RegistrationModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegistrationModel();
        result.init(data);
        return result;
    };
    RegistrationModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null;
        data["password"] = this.password !== undefined ? this.password : null;
        data["passwordConfirmation"] = this.passwordConfirmation !== undefined ? this.passwordConfirmation : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["state"] = this.state !== undefined ? this.state : null;
        data["phone"] = this.phone !== undefined ? this.phone : null;
        return data;
    };
    RegistrationModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new RegistrationModel();
        result.init(json);
        return result;
    };
    return RegistrationModel;
}());
exports.RegistrationModel = RegistrationModel;
var ResetPasswordResponseModel = /** @class */ (function (_super) {
    __extends(ResetPasswordResponseModel, _super);
    function ResetPasswordResponseModel(data) {
        return _super.call(this, data) || this;
    }
    ResetPasswordResponseModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
    };
    ResetPasswordResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetPasswordResponseModel();
        result.init(data);
        return result;
    };
    ResetPasswordResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    ResetPasswordResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ResetPasswordResponseModel();
        result.init(json);
        return result;
    };
    return ResetPasswordResponseModel;
}(ResponseBaseModel));
exports.ResetPasswordResponseModel = ResetPasswordResponseModel;
var ResetPasswordModel = /** @class */ (function () {
    function ResetPasswordModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetPasswordModel.prototype.init = function (data) {
        if (data) {
            this.email = data["email"] !== undefined ? data["email"] : null;
        }
    };
    ResetPasswordModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetPasswordModel();
        result.init(data);
        return result;
    };
    ResetPasswordModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null;
        return data;
    };
    ResetPasswordModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ResetPasswordModel();
        result.init(json);
        return result;
    };
    return ResetPasswordModel;
}());
exports.ResetPasswordModel = ResetPasswordModel;
var GetEmailFromCodeResponseModel = /** @class */ (function (_super) {
    __extends(GetEmailFromCodeResponseModel, _super);
    function GetEmailFromCodeResponseModel(data) {
        return _super.call(this, data) || this;
    }
    GetEmailFromCodeResponseModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.email = data["email"] !== undefined ? data["email"] : null;
        }
    };
    GetEmailFromCodeResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetEmailFromCodeResponseModel();
        result.init(data);
        return result;
    };
    GetEmailFromCodeResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    GetEmailFromCodeResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new GetEmailFromCodeResponseModel();
        result.init(json);
        return result;
    };
    return GetEmailFromCodeResponseModel;
}(ResponseBaseModel));
exports.GetEmailFromCodeResponseModel = GetEmailFromCodeResponseModel;
var NewPasswordModel = /** @class */ (function () {
    function NewPasswordModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NewPasswordModel.prototype.init = function (data) {
        if (data) {
            this.email = data["email"] !== undefined ? data["email"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.password = data["password"] !== undefined ? data["password"] : null;
            this.passwordConfirmation = data["passwordConfirmation"] !== undefined ? data["passwordConfirmation"] : null;
        }
    };
    NewPasswordModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NewPasswordModel();
        result.init(data);
        return result;
    };
    NewPasswordModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["password"] = this.password !== undefined ? this.password : null;
        data["passwordConfirmation"] = this.passwordConfirmation !== undefined ? this.passwordConfirmation : null;
        return data;
    };
    NewPasswordModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new NewPasswordModel();
        result.init(json);
        return result;
    };
    return NewPasswordModel;
}());
exports.NewPasswordModel = NewPasswordModel;
var ValidateResponseModel = /** @class */ (function (_super) {
    __extends(ValidateResponseModel, _super);
    function ValidateResponseModel(data) {
        return _super.call(this, data) || this;
    }
    ValidateResponseModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.userId = data["userId"] !== undefined ? data["userId"] : null;
            this.userPhone = data["userPhone"] !== undefined ? data["userPhone"] : null;
        }
    };
    ValidateResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidateResponseModel();
        result.init(data);
        return result;
    };
    ValidateResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["userPhone"] = this.userPhone !== undefined ? this.userPhone : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    ValidateResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ValidateResponseModel();
        result.init(json);
        return result;
    };
    return ValidateResponseModel;
}(ResponseBaseModel));
exports.ValidateResponseModel = ValidateResponseModel;
var ValidatePhoneModel = /** @class */ (function () {
    function ValidatePhoneModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ValidatePhoneModel.prototype.init = function (data) {
        if (data) {
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.userId = data["userId"] !== undefined ? data["userId"] : null;
        }
    };
    ValidatePhoneModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidatePhoneModel();
        result.init(data);
        return result;
    };
    ValidatePhoneModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null;
        data["userId"] = this.userId !== undefined ? this.userId : null;
        return data;
    };
    ValidatePhoneModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ValidatePhoneModel();
        result.init(json);
        return result;
    };
    return ValidatePhoneModel;
}());
exports.ValidatePhoneModel = ValidatePhoneModel;
var ValidateModel = /** @class */ (function () {
    function ValidateModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ValidateModel.prototype.init = function (data) {
        if (data) {
            this.value = data["value"] !== undefined ? data["value"] : null;
            this.type = data["type"] !== undefined ? data["type"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
        }
    };
    ValidateModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidateModel();
        result.init(data);
        return result;
    };
    ValidateModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null;
        data["type"] = this.type !== undefined ? this.type : null;
        data["code"] = this.code !== undefined ? this.code : null;
        return data;
    };
    ValidateModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ValidateModel();
        result.init(json);
        return result;
    };
    return ValidateModel;
}());
exports.ValidateModel = ValidateModel;
var SwaggerException = /** @class */ (function (_super) {
    __extends(SwaggerException, _super);
    function SwaggerException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isSwaggerException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    SwaggerException.isSwaggerException = function (obj) {
        return obj.isSwaggerException === true;
    };
    return SwaggerException;
}(Error));
exports.SwaggerException = SwaggerException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        return rxjs_1.throwError(result);
    else
        return rxjs_1.throwError(new SwaggerException(message, status, response, headers, null));
}
function blobToText(blob) {
    return new rxjs_1.Observable(function (observer) {
        if (!blob) {
            observer.next("");
            observer.complete();
        }
        else {
            var reader = new FileReader();
            reader.onload = function (event) {
                observer.next(event.target.result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
